import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      "about.back": "Back",
      "about.framework.be.desc": "Focuses on your core values, identity statements, and habits.",
      "about.framework.be.title": "To Be (Identity)",
      "about.framework.do.desc": "Coordinates your daily tasks and immediate checklists.",
      "about.framework.do.title": "To Do (Actions)",
      "about.framework.title": "The Core Framework",
      "about.framework.want.desc": "Maps out your tangible goals and aspirations that support your identity.",
      "about.framework.want.title": "To Want (Goals)",
      "about.modes.corporate.desc": "For professional team alignment, company visions, and cascading OKRs.",
      "about.modes.corporate.title": "Corporate Space",
      "about.modes.family.desc": "For shared family values, invitations, and family vision boards.",
      "about.modes.family.title": "Family Space",
      "about.modes.personal.desc": "For private habit tracking, streaks, and daily reflections.",
      "about.modes.personal.title": "Personal Space",
      "about.modes.title": "One Framework, Three Workspaces",
      "about.philosophy.body": "Align is designed to help you live intentionally by connecting your daily tasks to your long-term life vision and who you are becoming.",
      "about.philosophy.title": "Our Philosophy",
      "about.tagline": "From Action to Identity",
      "about.title": "About Align",
      "about.values.calm.desc": "A minimalist user interface designed to reduce digital noise.",
      "about.values.calm.title": "Calm Focus",
      "about.values.intentionality.desc": "Eliminating busywork to focus on what matters.",
      "about.values.intentionality.title": "Intentionality",
      "about.values.reflection.desc": "Pausing to review progress via built-in checks.",
      "about.values.reflection.title": "Reflection",
      "about.values.title": "Our Design Principles",
      "aiChat.commit.error": "Failed to save items.",
      "aiChat.commit.success": "Added {{items}} to your system.",
      "aiChat.continue.hint": "Answer to continue the thread. ⌘ + Enter to send.",
      "aiChat.continue.placeholder": "Answer the question above, or add more...",
      "aiChat.empty": "I didn't find anything to add. Try being more specific about goals, tasks, or who you want to be.",
      "aiChat.extract.error": "AI couldn't process that. Try again?",
      "aiChat.fab.label": "Align Agent",
      "aiChat.hint": "⌘ + Enter to send. Tap the mic to speak.",
      "aiChat.listening": "Listening… speak naturally, I'll sort it out.",
      "aiChat.panel.close": "Close",
      "aiChat.placeholder.examples.0": "Tell me what's on your mind — goals, tasks, who you want to be...",
      "aiChat.placeholder.examples.1": "Try: \"I want to be a patient parent and read one book a month with my kids.\"",
      "aiChat.placeholder.examples.2": "Try: \"Run a half-marathon in October. Buy shoes this weekend.\"",
      "aiChat.placeholder.examples.3": "Try: \"Feeling burnt out. I need to set a hard 6pm stop.\"",
      "aiChat.reflections": "Reflections",
      "aiChat.review.commit": "Add to my system",
      "aiChat.review.followup": "Follow-up",
      "aiChat.review.nothingSelected": "Select at least one item to add.",
      "aiChat.review.title": "Review what I found",
      "aiChat.thread.reset": "Start over",
      "aiChat.voice.error": "Voice input failed.",
      "aiChat.voice.tooltip": "Speak instead of typing",
      "aiChat.voice.unsupported": "Voice input isn't supported in this browser.",
      "analytics.being.label": "To Be",
      "analytics.being.subtitle": "Identities & Values",
      "analytics.motivation.high": "You're making incredible progress. Keep aligning your actions with your vision.",
      "analytics.motivation.low": "The journey begins with a single step. Start today.",
      "analytics.motivation.medium": "Every small action brings you closer to who you want to become.",
      "analytics.reflections": "Reflections",
      "analytics.reflections.entries": "Journal entries",
      "analytics.streaks.active": "Active Streaks",
      "analytics.streaks.longest": "Longest: {{count}} days",
      "analytics.subtitle": "Track your journey from action to identity",
      "analytics.tasks.completed": "Tasks Completed",
      "analytics.tasks.rate": "{{rate}}% completion rate",
      "analytics.title": "Your Progress",
      "analytics.todo.label": "To Do",
      "analytics.todo.subtitle": "Actions & Tasks",
      "analytics.want.label": "To Want",
      "analytics.want.subtitle": "Goals & Desires",
      "analytics.wants.completed": "{{count}} completed",
      "analytics.wants.progress": "Wants Progress",
      "auth.email": "Email",
      "auth.google": "Continue with Google",
      "auth.loading": "Please wait...",
      "auth.loading.google": "Connecting...",
      "auth.loading.login": "Signing In...",
      "auth.loading.signup": "Creating Account...",
      "auth.login": "Welcome Back",
      "auth.name": "Name",
      "auth.or": "Or",
      "auth.password": "Password",
      "auth.signup": "Create Account",
      "auth.submit.login": "Sign In",
      "auth.submit.signup": "Create Account",
      "auth.toggle.login": "Don't have an account? Sign up",
      "auth.toggle.signup": "Already have an account? Sign in",
      "auth.verify.backToHome": "Back to Home",
      "auth.verify.error": "Verification failed. The link may have expired or is invalid.",
      "auth.verify.errorTitle": "Verification Failed",
      "auth.verify.goToLogin": "Go to Login",
      "auth.verify.needed": "Please verify your email address before logging in.",
      "auth.verify.noToken": "No verification token provided.",
      "auth.verify.resend": "Resend email",
      "auth.verify.resentBody": "If an account exists for that email, a new verification link has been sent.",
      "auth.verify.successBody": "Your email has been successfully verified. You can now log in to your account.",
      "auth.verify.successTitle": "Account Verified!",
      "auth.verify.verifyingBody": "Please wait while we confirm your email address...",
      "auth.verify.verifyingTitle": "Verifying Email",
      "being.days": "days",
      "being.description.placeholder": "Describe this aspect of yourself...",
      "being.empty": "Who are you becoming?",
      "being.practice": "Practice Today",
      "being.streak": "Streak",
      "being.title.placeholder": "Who are you becoming?",
      "being.type.habit": "Habit",
      "being.type.identity": "Identity",
      "being.type.value": "Value",
      "corporate.firstTime.cta": "Create workspace",
      "corporate.firstTime.subtitle": "A workspace is where you align a team or family around shared vision, goals, and key results. You can be in more than one.",
      "corporate.firstTime.title": "Set up your first workspace",
      "corporate.goal.createError": "Couldn't add that.",
      "corporate.goal.created": "Added.",
      "corporate.goal.deleteConfirm": "Delete this goal? Any sub-items linked to it will also be removed.",
      "corporate.goal.deleteError": "Couldn't delete.",
      "corporate.goal.deleted": "Deleted.",
      "corporate.goal.progress": "Progress",
      "corporate.goal.updateError": "Couldn't update progress.",
      "corporate.goals.fetchError": "Couldn't load goals.",
      "corporate.kr.add": "Add Key Result",
      "corporate.kr.descPlaceholder": "Optional context.",
      "corporate.kr.titlePlaceholder": "What measurable result proves the OKR?",
      "corporate.level.kr": "Key Result",
      "corporate.level.okr": "OKR",
      "corporate.level.vision": "Vision",
      "corporate.loading": "Loading your workspaces...",
      "corporate.okr.add": "Add OKR",
      "corporate.okr.descPlaceholder": "Optional context.",
      "corporate.okr.titlePlaceholder": "What objective serves this vision?",
      "corporate.type.corporate": "Corporate",
      "corporate.type.corporateDesc": "Team or org. Cascading vision → OKRs → KRs.",
      "corporate.type.family": "Family",
      "corporate.type.familyDesc": "Household. Shared values & yearly themes.",
      "corporate.vision.add": "Add Vision",
      "corporate.vision.descPlaceholder": "Optional context, the why.",
      "corporate.vision.empty": "No vision set yet. Start with a single statement of what this workspace is here to achieve.",
      "corporate.vision.titlePlaceholder": "What is this workspace here to accomplish?",
      "corporate.workspace.create": "Create",
      "corporate.workspace.createError": "Couldn't create workspace.",
      "corporate.workspace.created": "Workspace created.",
      "corporate.workspace.descLabel": "Description (optional)",
      "corporate.workspace.descPlaceholder": "What does this workspace exist to do?",
      "corporate.workspace.nameLabel": "Name",
      "corporate.workspace.namePlaceholder": "e.g. Acme Marketing, The Smith Family",
      "corporate.workspace.new": "New workspace",
      "corporate.workspace.newSubtitle": "Give it a name and you can start cascading vision into action.",
      "corporate.workspace.newTitle": "Create a workspace",
      "corporate.workspace.typeLabel": "Type",
      "corporate.workspaces.fetchError": "Couldn't load your workspaces.",
      "family.cat.annual_themes.contentPlaceholder": "What does this theme look like? What would prove it true at year-end?",
      "family.cat.annual_themes.empty": "What's this year's theme? Pick one or two — not ten.",
      "family.cat.annual_themes.tagline": "The themes that shape this year. One word or one sentence.",
      "family.cat.annual_themes.title": "This Year",
      "family.cat.annual_themes.titlePlaceholder": "e.g. The Year of Outdoors, Year of Listening",
      "family.cat.dreams.contentPlaceholder": "Why this dream? What would it feel like?",
      "family.cat.dreams.empty": "Write down something nobody in the family has dared to say out loud.",
      "family.cat.dreams.tagline": "The longer-arc what-ifs. No deadlines, no shame.",
      "family.cat.dreams.title": "Dreams",
      "family.cat.dreams.titlePlaceholder": "e.g. Travel through New Zealand, Build a treehouse",
      "family.cat.values.contentPlaceholder": "What does this value look like in practice for us?",
      "family.cat.values.empty": "No values written down yet. Start with one that matters most.",
      "family.cat.values.tagline": "What this family stands for. The non-negotiables.",
      "family.cat.values.title": "Values",
      "family.cat.values.titlePlaceholder": "e.g. Honesty, Adventure, Showing up",
      "family.createError": "Couldn't add that.",
      "family.created": "Added.",
      "family.deleteConfirm": "Remove this item from the vision board?",
      "family.deleteError": "Couldn't remove.",
      "family.deleted": "Removed.",
      "family.fetchError": "Couldn't load the vision board.",
      "family.loading": "Loading the board…",
      "family.subtitle": "Family vision board",
      "form.cancel": "Cancel",
      "form.create": "Create",
      "invite.acceptCta": "Accept invitation",
      "invite.acceptError": "Couldn't accept invitation.",
      "invite.acceptSuccess": "Joined {{workspace}}.",
      "invite.alreadyUsedBody": "This invitation has already been accepted.",
      "invite.alreadyUsedTitle": "Invitation already used",
      "invite.backToDashboard": "Back to dashboard",
      "invite.backToHome": "Back to home",
      "invite.errorTitle": "Invitation unavailable",
      "invite.expiredBody": "Ask the person who invited you to send a fresh link.",
      "invite.expiredTitle": "Invitation expired",
      "invite.heading": "Join {{workspace}}",
      "invite.label": "Invitation",
      "invite.loadError": "Couldn't load this invitation.",
      "invite.redirecting": "Taking you to your workspace…",
      "invite.signInToAccept": "Sign in to accept",
      "invite.subheading": "You've been invited as a {{role}} of {{workspace}}.",
      "invite.welcomeTitle": "Welcome to {{workspace}}",
      "landing.cta": "Begin Your Journey",
      "landing.description": "More than tasks. Connect what you <1>do</1> to what you <3>want</3>, and who you're <5>becoming</5>.",
      "landing.tagline": "From Action to Identity",
      "landing.title": "Align",
      "layer.being": "To Be",
      "layer.being.subtitle": "Identity & Values",
      "layer.todo": "To Do",
      "layer.todo.subtitle": "Today's Actions",
      "layer.want": "To Want",
      "layer.want.subtitle": "Goals & Desires",
      "members.invite.copyFail": "Couldn't copy link.",
      "members.invite.copyLink": "Copy invite link",
      "members.invite.emailPlaceholder": "name@example.com",
      "members.invite.error": "Couldn't send invitation.",
      "members.invite.linkCopied": "Invite link copied to clipboard.",
      "members.invite.linkHint": "An email goes out if configured. The invite link is auto-copied so you can share it directly.",
      "members.invite.revoke": "Revoke",
      "members.invite.revokeConfirm": "Revoke this invitation? The link will stop working.",
      "members.invite.revokeError": "Couldn't revoke invitation.",
      "members.invite.revoked": "Invitation revoked.",
      "members.invite.send": "Send",
      "members.invite.sent": "Invitation sent.",
      "members.invite.title": "Invite a teammate",
      "members.list.title": "Members ({{count}})",
      "members.list.you": "you",
      "members.loadError": "Couldn't load members.",
      "members.loading": "Loading members…",
      "members.pending.title": "Pending invitations ({{count}})",
      "members.role.admin": "Admin",
      "members.role.manager": "Manager",
      "members.role.member": "Member",
      "members.title": "Members",
      "mode.corporate": "Corporate",
      "mode.family": "Family",
      "mode.personal": "Personal",
      "nav.about": "About",
      "nav.back": "Back to Dashboard",
      "nav.calendar": "Calendar",
      "nav.dashboard": "Dashboard",
      "nav.help": "Help",
      "nav.logout": "Logout",
      "nav.progress": "Progress",
      "nav.reflect": "Reflect",
      "reflection.empty": "No reflections yet. Start your journey above!",
      "reflection.past": "Past Reflections",
      "reflection.placeholder": "Write your thoughts here...",
      "reflection.save": "Save Reflection",
      "reflection.saving": "Saving...",
      "reflection.subtitle": "Take a moment to pause and reflect on your journey",
      "reflection.title": "Daily Reflection",
      "review.dismiss": "Hide for now",
      "review.engage": "Reflect on it",
      "review.label": "Weekly check-in",
      "review.skipWeek": "Skip this week",
      "review.statsCompleted": "{{done}} of {{total}} aligned actions this week",
      "toast.auth.error": "Authentication failed",
      "toast.being.created": "Being created",
      "toast.being.deleted": "Being deleted",
      "toast.being.error": "Failed to create being",
      "toast.reflection.error": "Failed to save reflection",
      "toast.reflection.saved": "Reflection saved",
      "toast.session.expired": "Session expired. Please login again.",
      "toast.streak": "Streak: {{count}} days!",
      "toast.todo.created": "Task created",
      "toast.todo.deleted": "Task deleted",
      "toast.todo.error": "Failed to create task",
      "toast.want.created": "Want created",
      "toast.want.deleted": "Want deleted",
      "toast.want.error": "Failed to create want",
      "toast.welcome.login": "Welcome back!",
      "toast.welcome.signup": "Welcome to Align!",
      "today.embody": "Embody",
      "today.empty": "Nothing on deck. Add a todo or ask the assistant below.",
      "today.label": "Today",
      "today.next": "Next steps",
      "todo.connect.being": "Connect to a Being (optional)",
      "todo.connect.want": "Connect to a Want (optional)",
      "todo.description.placeholder": "Details (optional)",
      "todo.empty": "No tasks yet. Create one to start!",
      "todo.title.placeholder": "What needs to be done?",
      "tour.btn.done": "Done",
      "tour.btn.next": "Next",
      "tour.btn.prev": "Prev",
      "tour.helpTooltip": "Help Tour",
      "tour.step1.desc": "Align helps you bridge the gap between who you want to be and what you do every day. We've started you on a 14-day Free Trial of Align Pro (with unlimited access & AI coaching!). Let's take a quick 1-minute tour to see how it works.",
      "tour.step1.title": "Welcome to Align",
      "tour.step2.desc": "This is the root of your cascade. Define who you want to become or what values you want to practice (e.g., 'Senior Software Developer' or 'Healthy Runner').",
      "tour.step2.title": "1. To Be (Identity & Values)",
      "tour.step3.desc": "Set concrete goals that support your identities. For example, 'Master Distributed System Design' supports your developer identity.",
      "tour.step3.title": "2. To Want (Goals & Desires)",
      "tour.step4.desc": "Create immediate tasks here and link them to your goals. The progress bars on your goals will automatically update as you check off these tasks!",
      "tour.step4.title": "3. To Do (Today's Actions)",
      "tour.step5.desc": "Your sidebar shows your focus identity for today, your weekly check-in, and the top 3 high-priority tasks to focus on next.",
      "tour.step5.title": "Your Daily Cockpit",
      "tour.step6.desc": "Talk to your AI coach here. Write reflections about your day, and the AI will automatically extract and link new identities, goals, and tasks for you!",
      "tour.step6.title": "AI Reflect & Coach",
      "tour.step7.desc": "Click 'Calendar' to view and customize your daily schedule, click 'Reflect' to write daily journal entries and view your reflection history, or click 'Progress' to view your visual analytics dashboard and streaks over time.",
      "tour.step7.title": "Schedule, Reflect & Track Progress",
      "tour.calendar.step1.desc": "Welcome to your calendar. Here you can organize your daily activities in a visual timeline.",
      "tour.calendar.step1.title": "Day Planner Cockpit",
      "tour.calendar.step2.desc": "Move between days to schedule tasks in advance or review how you spent past days.",
      "tour.calendar.step2.title": "Date Navigation",
      "tour.calendar.step3.desc": "This panel holds all your active Beings, Wants, and Todos that have not yet been placed on today's schedule.",
      "tour.calendar.step3.title": "Unscheduled Items",
      "tour.calendar.step4.desc": "Click \"+ Add block to this time\" to pick a task from your unscheduled list and block out time for it.",
      "tour.calendar.step4.title": "Hourly Timeline",
      "tour.calendar.step5.desc": "Click this button to switch back and forth between the Calendar and your three-column Dashboard.",
      "tour.calendar.step5.title": "Switch View Mode",
      "want.description.placeholder": "Why does this matter to you?",
      "want.empty": "No goals yet. What do you want?",
      "want.progress": "Progress",
      "want.title.placeholder": "What do you want?",
      "workspace.corporate.createCta": "Create",
      "workspace.corporate.descPlaceholder": "What does this workspace exist to do?",
      "workspace.corporate.firstTime.cta": "Create workspace",
      "workspace.corporate.firstTime.subtitle": "A workspace for your team or org. Cascade vision into OKRs and key results. Invite collaborators when you're ready.",
      "workspace.corporate.firstTime.title": "Set up your first workspace",
      "workspace.corporate.namePlaceholder": "e.g. Acme Marketing, Engineering Pod",
      "workspace.corporate.newOption": "New workspace",
      "workspace.corporate.newSubtitle": "Give it a name and you can start cascading vision into action.",
      "workspace.corporate.newTitle": "Create a workspace",
      "workspace.family.createCta": "Create",
      "workspace.family.descPlaceholder": "What pulls this family forward together?",
      "workspace.family.firstTime.cta": "Create family workspace",
      "workspace.family.firstTime.subtitle": "A shared space for your household. Capture values, themes for this year, and dreams worth chasing together.",
      "workspace.family.firstTime.title": "Set up your family workspace",
      "workspace.family.namePlaceholder": "e.g. The Smith Family, Our 2026",
      "workspace.family.newOption": "New family workspace",
      "workspace.family.newSubtitle": "Name it after the family or the shared chapter. You can be in more than one.",
      "workspace.family.newTitle": "Create a family workspace",
      "calendar.title": "Day Schedule",
      "calendar.loading": "Loading schedule...",
      "calendar.continued": "Continued:",
      "calendar.until": "(until {{time}})",
      "calendar.addBlock": "+ Add block to this time",
      "calendar.addBlockPrompt": "Add block to this time",
      "calendar.editSchedule": "Edit Schedule: {{title}}",
      "calendar.scheduleTitle": "Schedule: {{title}}",
      "calendar.startTime": "START TIME",
      "calendar.duration": "DURATION",
      "calendar.itemType": "ITEM TYPE",
      "calendar.description": "DESCRIPTION",
      "calendar.unschedule": "Unschedule",
      "calendar.cancel": "Cancel",
      "calendar.update": "Update",
      "calendar.schedule": "Schedule",
      "calendar.hours": "Hours",
      "calendar.mins": "Mins",
      "calendar.custom": "Custom...",
      "calendar.unscheduledItems": "Unscheduled Items",
      "calendar.beings": "Beings (Identities & Habits)",
      "calendar.wants": "Wants (Goals & Desires)",
      "calendar.todos": "Todos (Today's Actions)",
      "calendar.noneUnscheduled": "None unscheduled",
      "welcome.success": "Welcome onboard! Your workspace is ready.",
      "welcome.error": "Failed to initialize workspace. Please try again.",
      "welcome.trial.title": "Welcome to Align Pro",
      "welcome.trial.subtitle": "Your 14-day free trial is active. Select a focus area to seed your first goal cascade.",
      "welcome.focus.section_title": "Choose your primary Focus Area:",
      "welcome.focus.health.title": "Health & Vitality",
      "welcome.focus.health.desc": "Build physical energy, healthy habits, and daily exercise.",
      "welcome.focus.career.title": "Career & Focus",
      "welcome.focus.career.desc": "Enhance productivity, achieve project goals, and plan work.",
      "welcome.focus.mindfulness.title": "Mindfulness & Presence",
      "welcome.focus.mindfulness.desc": "Cultivate daily reflection, reduce screen time, and stay present.",
      "welcome.focus.blank.title": "Explore Freely (Blank)",
      "welcome.focus.blank.desc": "Start with a clean sheet. Create your own custom cascade from scratch.",
      "welcome.trial.highlight": "Pro Trial Activated",
      "welcome.trial.highlight_desc": "You have full access to Live AI Coaching, Family/Corporate Workspaces, and Unlimited Goals. No credit card is required.",
      "welcome.loading": "Initializing Workspace...",
      "welcome.trial.cta": "Enter My Workspace",
      "welcome.trial.guarantee": "No auto-charges.",
      "tour.step_stalled.title": "Stalled Goals Nudge",
      "tour.step_stalled.desc_pro": "When goals lose momentum, this card helps you archive them or reflect with your AI Coach to get unstuck.",
      "tour.step_stalled.desc_starter": "When goals lose momentum, this card helps you archive them or add a small immediate action to get unstuck.",
      "dialog.delete.being.title": "Delete this Being?",
      "dialog.delete.being.desc": "All connected goals and tasks will be removed along with this identity.",
      "dialog.delete.want.title": "Delete this Goal?",
      "dialog.delete.want.desc": "All connected tasks will be deleted along with this goal.",
      "dialog.delete.todo.title": "Delete this Task?",
      "dialog.delete.todo.desc": "This task will be permanently deleted.",
      "dialog.delete.confirm": "Delete",
      "dialog.delete.cancel": "Cancel"
    }
  },
  es: {
    translation: {
      "about.back": "Volver",
      "about.framework.be.desc": "Se centra en tus valores fundamentales, declaraciones de identidad y hábitos.",
      "about.framework.be.title": "Ser (Identidad)",
      "about.framework.do.desc": "Coordina tus tareas diarias y listas de verificación inmediatas.",
      "about.framework.do.title": "Hacer (Acciones)",
      "about.framework.title": "El Marco Central",
      "about.framework.want.desc": "Mapea tus metas y aspiraciones tangibles que respaldan tu identidad.",
      "about.framework.want.title": "Querer (Metas)",
      "about.modes.corporate.desc": "Para la alineación de equipos profesionales, visiones corporativas y OKR en cascada.",
      "about.modes.corporate.title": "Espacio Corporativo",
      "about.modes.family.desc": "Para valores familiares compartidos, invitaciones y tableros de visión familiar.",
      "about.modes.family.title": "Espacio Familiar",
      "about.modes.personal.desc": "Para el seguimiento de hábitos privados, rachas y reflexiones diarias.",
      "about.modes.personal.title": "Espacio Personal",
      "about.modes.title": "Un Marco, Tres Espacios",
      "about.philosophy.body": "Align está diseñado para ayudarte a vivir intencionalmente conectando tus tareas diarias con tu visión de vida a largo plazo y quién estás llegando a ser.",
      "about.philosophy.title": "Nuestra Filosofía",
      "about.tagline": "De la Acción a la Identidad",
      "about.title": "Acerca de Align",
      "about.values.calm.desc": "Una interfaz de usuario minimalista diseñada para reducir el ruido digital.",
      "about.values.calm.title": "Enfoque Calmo",
      "about.values.intentionality.desc": "Eliminar el trabajo innecesario para enfocarse en lo que importa.",
      "about.values.intentionality.title": "Intencionalidad",
      "about.values.reflection.desc": "Pausar para revisar el progreso a través de verificaciones integradas.",
      "about.values.reflection.title": "Reflexión",
      "about.values.title": "Nuestros Principios de Diseño",
      "aiChat.commit.error": "Error al guardar los elementos.",
      "aiChat.commit.success": "Se agregaron {{items}} elementos a tu sistema.",
      "aiChat.continue.hint": "Responde para continuar el hilo. ⌘ + Enter para enviar.",
      "aiChat.continue.placeholder": "Responde a la pregunta anterior o agrega más...",
      "aiChat.empty": "No encontré nada para agregar. Intenta ser más específico con tus metas, tareas o quién quieres ser.",
      "aiChat.extract.error": "La IA no pudo procesar eso. ¿Intentar de nuevo?",
      "aiChat.fab.label": "Agente Align",
      "aiChat.hint": "⌘ + Enter para enviar. Toca el micrófono para hablar.",
      "aiChat.listening": "Escuchando... habla con naturalidad, yo me encargo.",
      "aiChat.panel.close": "Cerrar",
      "aiChat.placeholder.examples.0": "Dime qué tienes en mente: metas, tareas, quién quieres ser...",
      "aiChat.placeholder.examples.1": "Prueba: ",
      "aiChat.placeholder.examples.2": "Prueba: ",
      "aiChat.placeholder.examples.3": "Prueba: ",
      "aiChat.reflections": "Reflexiones",
      "aiChat.review.commit": "Agregar a mi sistema",
      "aiChat.review.followup": "Seguimiento",
      "aiChat.review.nothingSelected": "Selecciona al menos un elemento para agregar.",
      "aiChat.review.title": "Revisar lo que encontré",
      "aiChat.thread.reset": "Empezar de nuevo",
      "aiChat.voice.error": "Falló la entrada de voz.",
      "aiChat.voice.tooltip": "Hablar en lugar de escribir",
      "aiChat.voice.unsupported": "La entrada de voz no es compatible con este navegador.",
      "analytics.being.label": "Ser",
      "analytics.being.subtitle": "Identidades y Valores",
      "analytics.motivation.high": "Estás haciendo un progreso increíble. Sigue alineando tus acciones con tu visión.",
      "analytics.motivation.low": "El viaje comienza con un solo paso. Empieza hoy.",
      "analytics.motivation.medium": "Cada pequeña acción te acerca a quien quieres ser.",
      "analytics.reflections": "Reflexiones",
      "analytics.reflections.entries": "Entradas de diario",
      "analytics.streaks.active": "Rachas Activas",
      "analytics.streaks.longest": "Más larga: {{count}} días",
      "analytics.subtitle": "Rastrea tu viaje desde la acción hasta la identidad",
      "analytics.tasks.completed": "Tareas Completadas",
      "analytics.tasks.rate": "{{rate}}% tasa de finalización",
      "analytics.title": "Tu Progreso",
      "analytics.todo.label": "Hacer",
      "analytics.todo.subtitle": "Acciones y Tareas",
      "analytics.want.label": "Querer",
      "analytics.want.subtitle": "Metas y Deseos",
      "analytics.wants.completed": "{{count}} completados",
      "analytics.wants.progress": "Progreso de Deseos",
      "auth.email": "Correo Electrónico",
      "auth.google": "Continuar con Google",
      "auth.loading": "Por favor espera...",
      "auth.loading.google": "Conectando...",
      "auth.loading.login": "Iniciando sesión...",
      "auth.loading.signup": "Creando cuenta...",
      "auth.login": "Bienvenido de Nuevo",
      "auth.name": "Nombre",
      "auth.or": "O",
      "auth.password": "Contraseña",
      "auth.signup": "Crear Cuenta",
      "auth.submit.login": "Iniciar Sesión",
      "auth.submit.signup": "Crear Cuenta",
      "auth.toggle.login": "¿No tienes cuenta? Regístrate",
      "auth.toggle.signup": "¿Ya tienes cuenta? Inicia sesión",
      "auth.verify.backToHome": "Volver al inicio",
      "auth.verify.error": "La verificación falló. El enlace puede haber expirado o no ser válido.",
      "auth.verify.errorTitle": "Verificación fallida",
      "auth.verify.goToLogin": "Ir al inicio de sesión",
      "auth.verify.needed": "Por favor, verifica tu dirección de correo electrónico antes de iniciar sesión.",
      "auth.verify.noToken": "No se proporcionó un token de verificación.",
      "auth.verify.resend": "Reenviar correo electrónico",
      "auth.verify.resentBody": "Si existe una cuenta para ese correo, se ha enviado un nuevo enlace de verificación.",
      "auth.verify.successBody": "Tu correo electrónico ha sido verificado con éxito. Ya puedes iniciar sesión.",
      "auth.verify.successTitle": "¡Cuenta verificada!",
      "auth.verify.verifyingBody": "Por favor, espera mientras confirmamos tu dirección de correo...",
      "auth.verify.verifyingTitle": "Verificando correo electrónico",
      "being.days": "días",
      "being.description.placeholder": "Describe este aspecto de ti mismo...",
      "being.empty": "¿En quién te estás convirtiendo?",
      "being.practice": "Practicar Hoy",
      "being.streak": "Racha",
      "being.title.placeholder": "¿En quién te estás convirtiendo?",
      "being.type.habit": "Hábito",
      "being.type.identity": "Identidad",
      "being.type.value": "Valor",
      "corporate.firstTime.cta": "Crear espacio de trabajo",
      "corporate.firstTime.subtitle": "Un espacio de trabajo te permite alinear un equipo o familia en torno a una visión, metas y resultados clave compartidos.",
      "corporate.firstTime.title": "Configura tu primer espacio de trabajo",
      "corporate.goal.createError": "No se pudo agregar.",
      "corporate.goal.created": "Agregado.",
      "corporate.goal.deleteConfirm": "¿Eliminar esta meta? También se eliminarán los sub-elementos vinculados.",
      "corporate.goal.deleteError": "No se pudo eliminar.",
      "corporate.goal.deleted": "Eliminado.",
      "corporate.goal.progress": "Progreso",
      "corporate.goal.updateError": "No se pudo actualizar el progreso.",
      "corporate.goals.fetchError": "No se pudieron cargar las metas.",
      "corporate.kr.add": "Agregar resultado clave",
      "corporate.kr.descPlaceholder": "Contexto opcional.",
      "corporate.kr.titlePlaceholder": "¿Qué resultado medible demuestra el OKR?",
      "corporate.level.kr": "Resultado clave",
      "corporate.level.okr": "OKR",
      "corporate.level.vision": "Visión",
      "corporate.loading": "Cargando tus espacios de trabajo...",
      "corporate.okr.add": "Agregar OKR",
      "corporate.okr.descPlaceholder": "Contexto opcional.",
      "corporate.okr.titlePlaceholder": "¿Qué objetivo sirve a esta visión?",
      "corporate.type.corporate": "Corporativo",
      "corporate.type.corporateDesc": "Equipo u organización. Visión en cascada → OKRs → KRs.",
      "corporate.type.family": "Familiar",
      "corporate.type.familyDesc": "Hogar. Valores compartidos y temas anuales.",
      "corporate.vision.add": "Agregar visión",
      "corporate.vision.descPlaceholder": "Contexto opcional, el porqué.",
      "corporate.vision.empty": "Aún no se ha establecido ninguna visión. Comienza con una declaración de lo que este espacio busca lograr.",
      "corporate.vision.titlePlaceholder": "¿Qué busca lograr este espacio de trabajo?",
      "corporate.workspace.create": "Crear",
      "corporate.workspace.createError": "No se pudo crear el espacio de trabajo.",
      "corporate.workspace.created": "Espacio de trabajo creado.",
      "corporate.workspace.descLabel": "Descripción (opcional)",
      "corporate.workspace.descPlaceholder": "¿Para qué existe este espacio de trabajo?",
      "corporate.workspace.nameLabel": "Nombre",
      "corporate.workspace.namePlaceholder": "ej. Acme Marketing, La Familia Pérez",
      "corporate.workspace.new": "Nuevo espacio de trabajo",
      "corporate.workspace.newSubtitle": "Dale un nombre para comenzar a estructurar tu visión en acción.",
      "corporate.workspace.newTitle": "Crear un espacio de trabajo",
      "corporate.workspace.typeLabel": "Tipo",
      "corporate.workspaces.fetchError": "No se pudieron cargar tus espacios de trabajo.",
      "family.cat.annual_themes.contentPlaceholder": "¿Cómo se ve este tema? ¿Qué lo demostraría al final del año?",
      "family.cat.annual_themes.empty": "¿Cuál es el tema de este año? Elige uno o dos, no diez.",
      "family.cat.annual_themes.tagline": "Los temas que dan forma a este año. Una palabra o una frase.",
      "family.cat.annual_themes.title": "Este año",
      "family.cat.annual_themes.titlePlaceholder": "ej. El año al aire libre, Año de escuchar",
      "family.cat.dreams.contentPlaceholder": "¿Por qué este sueño? ¿Cómo se sentiría?",
      "family.cat.dreams.empty": "Escribe algo que nadie en la familia se haya atrevido a decir en voz alta.",
      "family.cat.dreams.tagline": "Los deseos a más largo plazo. Sin plazos, sin vergüenza.",
      "family.cat.dreams.title": "Sueños",
      "family.cat.dreams.titlePlaceholder": "ej. Viajar por Nueva Zelanda, Construir una cabaña en un árbol",
      "family.cat.values.contentPlaceholder": "¿Cómo se ve este valor en la práctica para nosotros?",
      "family.cat.values.empty": "Aún no se han escrito valores. Comienza con el que más importe.",
      "family.cat.values.tagline": "Lo que representa esta familia. Los no negociables.",
      "family.cat.values.title": "Valores",
      "family.cat.values.titlePlaceholder": "ej. Honestidad, Aventura, Estar presente",
      "family.createError": "No se pudo agregar eso.",
      "family.created": "Agregado.",
      "family.deleteConfirm": "¿Quitar este elemento del tablero de visión?",
      "family.deleteError": "No se pudo quitar.",
      "family.deleted": "Quitado.",
      "family.fetchError": "No se pudo cargar el tablero de visión.",
      "family.loading": "Cargando el tablero...",
      "family.subtitle": "Tablero de visión familiar",
      "form.cancel": "Cancelar",
      "form.create": "Crear",
      "invite.acceptCta": "Aceptar invitación",
      "invite.acceptError": "No se pudo aceptar la invitación.",
      "invite.acceptSuccess": "Te has unido a {{workspace}}.",
      "invite.alreadyUsedBody": "Esta invitación ya ha sido aceptada.",
      "invite.alreadyUsedTitle": "Invitación ya utilizada",
      "invite.backToDashboard": "Volver al tablero",
      "invite.backToHome": "Volver al inicio",
      "invite.errorTitle": "Invitación no disponible",
      "invite.expiredBody": "Pídele a la persona que te invitó que envíe un nuevo enlace.",
      "invite.expiredTitle": "Invitación expirada",
      "invite.heading": "Unirse a {{workspace}}",
      "invite.label": "Invitación",
      "invite.loadError": "No se pudo cargar esta invitación.",
      "invite.redirecting": "Llevándote a tu espacio de trabajo...",
      "invite.signInToAccept": "Iniciar sesión para aceptar",
      "invite.subheading": "Has sido invitado como {{role}} de {{workspace}}.",
      "invite.welcomeTitle": "Bienvenido a {{workspace}}",
      "landing.cta": "Comienza tu Viaje",
      "landing.description": "Más que tareas. Conecta lo que <1>haces</1> con lo que <3>quieres</3>, y en quién te estás <5>convirtiendo</5>.",
      "landing.tagline": "De la Acción a la Identidad",
      "landing.title": "Alinear",
      "layer.being": "Ser",
      "layer.being.subtitle": "Identidad y Valores",
      "layer.todo": "Hacer",
      "layer.todo.subtitle": "Acciones de hoy",
      "layer.want": "Querer",
      "layer.want.subtitle": "Metas y Deseos",
      "members.invite.copyFail": "No se pudo copiar el enlace.",
      "members.invite.copyLink": "Copiar enlace de invitación",
      "members.invite.emailPlaceholder": "correo@ejemplo.com",
      "members.invite.error": "No se pudo enviar la invitación.",
      "members.invite.linkCopied": "Enlace de invitación copiado al portapapeles.",
      "members.invite.linkHint": "Se envía un correo si está configurado. El enlace se copia automáticamente para que lo compartas directamente.",
      "members.invite.revoke": "Revocar",
      "members.invite.revokeConfirm": "¿Revocar esta invitación? El enlace dejará de funcionar.",
      "members.invite.revokeError": "No se pudo revocar la invitación.",
      "members.invite.revoked": "Invitación revocada.",
      "members.invite.send": "Enviar",
      "members.invite.sent": "Invitación enviada.",
      "members.invite.title": "Invitar a un compañero",
      "members.list.title": "Miembros ({{count}})",
      "members.list.you": "tú",
      "members.loadError": "No se pudieron cargar los miembros.",
      "members.loading": "Cargando miembros...",
      "members.pending.title": "Invitaciones pendientes ({{count}})",
      "members.role.admin": "Administrador",
      "members.role.manager": "Gestor",
      "members.role.member": "Miembro",
      "members.title": "Miembros",
      "mode.corporate": "Corporativo",
      "mode.family": "Familiar",
      "mode.personal": "Personal",
      "nav.about": "Acerca de",
      "nav.back": "Volver al Panel",
      "nav.calendar": "Calendario",
      "nav.dashboard": "Panel",
      "nav.help": "Ayuda",
      "nav.logout": "Cerrar Sesión",
      "nav.progress": "Progreso",
      "nav.reflect": "Reflexionar",
      "reflection.empty": "No hay reflexiones aún. ¡Comienza tu viaje arriba!",
      "reflection.past": "Reflexiones Pasadas",
      "reflection.placeholder": "Escribe tus pensamientos aquí...",
      "reflection.save": "Guardar Reflexión",
      "reflection.saving": "Guardando...",
      "reflection.subtitle": "Tómate un momento para pausar y reflexionar sobre tu viaje",
      "reflection.title": "Reflexión Diaria",
      "review.dismiss": "Descartar por ahora",
      "review.engage": "Reflexionar sobre esto",
      "review.label": "Revisión semanal",
      "review.skipWeek": "Omitir esta semana",
      "review.statsCompleted": "Completaste {{done}} de {{total}} acciones alineadas esta semana",
      "toast.auth.error": "Falló la autenticación",
      "toast.being.created": "Ser creado",
      "toast.being.deleted": "Ser eliminado",
      "toast.being.error": "Error al crear ser",
      "toast.reflection.error": "Error al guardar reflexión",
      "toast.reflection.saved": "Reflexión guardada",
      "toast.session.expired": "Sesión expirada. Por favor inicia sesión de nuevo.",
      "toast.streak": "¡Racha: {{count}} días!",
      "toast.todo.created": "Tarea creada",
      "toast.todo.deleted": "Tarea eliminada",
      "toast.todo.error": "Error al crear tarea",
      "toast.want.created": "Deseo creado",
      "toast.want.deleted": "Deseo eliminado",
      "toast.want.error": "Error al crear deseo",
      "toast.welcome.login": "¡Bienvenido de nuevo!",
      "toast.welcome.signup": "¡Bienvenido a Alinear!",
      "today.embody": "Personificar",
      "today.empty": "Nada programado para hoy. Agrega una tarea o pregúntale al asistente.",
      "today.label": "Hoy",
      "today.next": "Próximos pasos",
      "todo.connect.being": "Conectar a un Ser (opcional)",
      "todo.connect.want": "Conectar a un Deseo (opcional)",
      "todo.description.placeholder": "Detalles (opcional)",
      "todo.empty": "No hay tareas aún. ¡Crea una para empezar!",
      "todo.title.placeholder": "¿Qué necesitas hacer?",
      "tour.btn.done": "Terminar",
      "tour.btn.next": "Siguiente",
      "tour.btn.prev": "Anterior",
      "tour.helpTooltip": "Guía de Ayuda",
      "tour.step1.desc": "Align te ayuda a cerrar la brecha entre quién quieres ser y lo que haces cada día. ¡Te hemos dado una prueba gratuita de 14 días de Align Pro (con acceso ilimitado y coaching de IA!). Hagamos un recorrido rápido de 1 minuto para ver cómo funciona.",
      "tour.step1.title": "Bienvenido a Align",
      "tour.step2.desc": "Esta es la raíz de tu cascada. Define en quién te quieres convertir o qué valores quieres practicar (ej. 'Desarrollador Senior' o 'Corredor Saludable').",
      "tour.step2.title": "1. To Be (Identidad y Valores)",
      "tour.step3.desc": "Establece metas concretas que respalden tus identidades. Por ejemplo, 'Dominar el Diseño de Sistemas' respalda tu identidad de desarrollador.",
      "tour.step3.title": "2. To Want (Metas y Deseos)",
      "tour.step4.desc": "Crea tareas inmediatas aquí y conéctalas con tus metas. ¡Las barras de progreso de tus metas se actualizarán automáticamente al completar tareas!",
      "tour.step4.title": "3. To Do (Acciones de Hoy)",
      "tour.step5.desc": "Tu barra lateral muestra tu identidad de enfoque para hoy, tu control semanal y las 3 tareas de mayor prioridad para enfocarte a continuación.",
      "tour.step5.title": "Tu Cabina Diaria",
      "tour.step6.desc": "Habla con tu coach de IA aquí. Escribe reflexiones sobre tu día, y la IA extraerá y conectará automáticamente nuevas identidades, metas y tareas para ti.",
      "tour.step6.title": "Reflexión y Coach de IA",
      "tour.step7.desc": "Haz clic en 'Calendar' (Calendario) para ver y personalizar tu horario diario, haz clic en 'Reflect' (Reflexionar) para escribir diarios y ver tu historial de reflexión, o haz clic en 'Progress' (Progreso) para ver tu panel de análisis visual y tus rachas.",
      "tour.step7.title": "Planifica, Reflexiona y Sigue tu Progreso",
      "tour.calendar.step1.desc": "Bienvenido a tu calendario. Aquí puedes organizar tus actividades diarias en una línea de tiempo visual.",
      "tour.calendar.step1.title": "Cabina del Planificador Diario",
      "tour.calendar.step2.desc": "Muévete entre días para programar tareas con anticipación o revisar cómo pasaste los días anteriores.",
      "tour.calendar.step2.title": "Navegación de Fechas",
      "tour.calendar.step3.desc": "Este panel contiene todas tus Identidades, Objetivos y Tareas activas que aún no se han colocado en el horario de hoy.",
      "tour.calendar.step3.title": "Elementos sin Programar",
      "tour.calendar.step4.desc": "Haz clic en \"+ Agregar bloque a este horario\" para elegir una tarea de tu lista sin programar y reservar tiempo para ella.",
      "tour.calendar.step4.title": "Línea de Tiempo Horaria",
      "tour.calendar.step5.desc": "Haz clic en este botón para alternar entre el Calendario y tu Panel de tres columnas.",
      "tour.calendar.step5.title": "Cambiar Modo de Vista",
      "want.description.placeholder": "¿Por qué te importa esto?",
      "want.empty": "No hay metas aún. ¿Qué quieres?",
      "want.progress": "Progreso",
      "want.title.placeholder": "¿Qué quieres?",
      "workspace.corporate.createCta": "Crear",
      "workspace.corporate.descPlaceholder": "¿Para qué existe este espacio de trabajo?",
      "workspace.corporate.firstTime.cta": "Crear espacio de trabajo",
      "workspace.corporate.firstTime.subtitle": "Un espacio de trabajo para tu equipo. Estructura la visión en OKRs y resultados clave. Invita a colaboradores cuando estés listo.",
      "workspace.corporate.firstTime.title": "Configura tu primer espacio de trabajo",
      "workspace.corporate.namePlaceholder": "ej. Acme Marketing, Equipo de Ingeniería",
      "workspace.corporate.newOption": "Nuevo espacio de trabajo",
      "workspace.corporate.newSubtitle": "Dale un nombre para comenzar a estructurar tu visión en acción.",
      "workspace.corporate.newTitle": "Crear un espacio de trabajo",
      "workspace.family.createCta": "Crear",
      "workspace.family.descPlaceholder": "¿Qué impulsa a esta familia hacia adelante?",
      "workspace.family.firstTime.cta": "Crear espacio familiar",
      "workspace.family.firstTime.subtitle": "Un espacio compartido para tu hogar. Captura valores, temas para este año y sueños que quieran lograr juntos.",
      "workspace.family.firstTime.title": "Configura tu espacio de trabajo familiar",
      "workspace.family.namePlaceholder": "ej. La Familia Pérez, Nuestro 2026",
      "workspace.family.newOption": "Nuevo espacio familiar",
      "workspace.family.newSubtitle": "Nómbralo según la familia o el capítulo compartido. Puedes estar en más de uno.",
      "workspace.family.newTitle": "Crear un espacio de trabajo familiar",
      "calendar.title": "Horario del Día",
      "calendar.loading": "Cargando horario...",
      "calendar.continued": "Continuado:",
      "calendar.until": "(hasta las {{time}})",
      "calendar.addBlock": "+ Añadir bloque a esta hora",
      "calendar.addBlockPrompt": "Añadir bloque a esta hora",
      "calendar.editSchedule": "Editar Horario: {{title}}",
      "calendar.scheduleTitle": "Horario: {{title}}",
      "calendar.startTime": "HORA DE INICIO",
      "calendar.duration": "DURACIÓN",
      "calendar.itemType": "TIPO DE ELEMENTO",
      "calendar.description": "DESCRIPCIÓN",
      "calendar.unschedule": "Desprogramar",
      "calendar.cancel": "Cancelar",
      "calendar.update": "Actualizar",
      "calendar.schedule": "Programar",
      "calendar.hours": "Horas",
      "calendar.mins": "Minutos",
      "calendar.custom": "Personalizado...",
      "calendar.unscheduledItems": "Elementos no Programados",
      "calendar.beings": "Seres (Identidades y Hábitos)",
      "calendar.wants": "Deseos (Metas y Anhelos)",
      "calendar.todos": "Deberes (Acciones de Hoy)",
      "calendar.noneUnscheduled": "Ninguno sin programar",
      "welcome.success": "¡Bienvenido a bordo! Tu espacio de trabajo está listo.",
      "welcome.error": "Error al inicializar el espacio de trabajo. Por favor, inténtalo de nuevo.",
      "welcome.trial.title": "Bienvenido a Align Pro",
      "welcome.trial.subtitle": "Tu prueba gratuita de 14 días está activa. Selecciona un área de enfoque para sembrar tu primera cascada de objetivos.",
      "welcome.focus.section_title": "Elige tu área de enfoque principal:",
      "welcome.focus.health.title": "Salud y Vitalidad",
      "welcome.focus.health.desc": "Desarrolla energía física, hábitos saludables y ejercicio diario.",
      "welcome.focus.career.title": "Carrera y Enfoque",
      "welcome.focus.career.desc": "Mejora la productividad, logra metas de proyectos y planifica el trabajo.",
      "welcome.focus.mindfulness.title": "Atención Plena y Presencia",
      "welcome.focus.mindfulness.desc": "Cultiva la reflexión diaria, reduce el tiempo de pantalla y mantente presente.",
      "welcome.focus.blank.title": "Explorar libremente (En blanco)",
      "welcome.focus.blank.desc": "Comienza con una hoja limpia. Crea tu propia cascada personalizada desde cero.",
      "welcome.trial.highlight": "Prueba Pro Activada",
      "welcome.trial.highlight_desc": "Tienes acceso completo a Coaching de IA en vivo, espacios de trabajo Familiares/Corporativos y objetivos ilimitados. No se requiere tarjeta de crédito.",
      "welcome.loading": "Inicializando espacio de trabajo...",
      "welcome.trial.cta": "Entrar a mi espacio de trabajo",
      "welcome.trial.guarantee": "Sin cargos automáticos.",
      "tour.step_stalled.title": "Aviso de Metas Estancadas",
      "tour.step_stalled.desc_pro": "Cuando las metas pierden impulso, esta tarjeta te ayuda a archivarlas o reflexionar con tu Coach de IA para reactivarte.",
      "tour.step_stalled.desc_starter": "Cuando las metas pierden impulso, esta tarjeta te ayuda a archivarlas o agregar una pequeña acción inmediata para reactivarte.",
      "dialog.delete.being.title": "¿Eliminar este Ser?",
      "dialog.delete.being.desc": "Se eliminarán todas las metas y tareas conectadas junto con esta identidad.",
      "dialog.delete.want.title": "¿Eliminar esta Meta?",
      "dialog.delete.want.desc": "Se eliminarán todas las tareas conectadas junto con esta meta.",
      "dialog.delete.todo.title": "¿Eliminar esta Tarea?",
      "dialog.delete.todo.desc": "Esta tarea se eliminará permanentemente.",
      "dialog.delete.confirm": "Eliminar",
      "dialog.delete.cancel": "Cancelar"
    }
  },
  fr: {
    translation: {
      "about.back": "Retour",
      "about.framework.be.desc": "Se concentre sur vos valeurs fondamentales, vos déclarations d'identité et vos habitudes.",
      "about.framework.be.title": "Être (Identité)",
      "about.framework.do.desc": "Coordonne vos tâches quotidiennes et vos listes de contrôle immédiates.",
      "about.framework.do.title": "Faire (Actions)",
      "about.framework.title": "Le Cadre Central",
      "about.framework.want.desc": "Cartographie vos objectifs tangibles et vos aspirations qui soutiennent votre identité.",
      "about.framework.want.title": "Vouloir (Objectifs)",
      "about.modes.corporate.desc": "Pour l'alignement professionnel des équipes, les visions d'entreprise et les OKR en cascade.",
      "about.modes.corporate.title": "Espace Entreprise",
      "about.modes.family.desc": "Pour les valeurs familiales partagées, les invitations et les tableaux de vision familiale.",
      "about.modes.family.title": "Espace Familial",
      "about.modes.personal.desc": "Pour le suivi des habitudes privées, les séries et les réflexions quotidiennes.",
      "about.modes.personal.title": "Espace Personnel",
      "about.modes.title": "Un Cadre, Trois Espaces",
      "about.philosophy.body": "Align est conçu pour vous aider à vivre intentionnellement en connectant vos tâches quotidiennes à votre vision de vie à long terme et à qui vous devenez.",
      "about.philosophy.title": "Notre Philosophie",
      "about.tagline": "De l'Action à l'Identité",
      "about.title": "À Propos d'Align",
      "about.values.calm.desc": "Une interface utilisateur minimaliste conçue pour réduire le bruit numérique.",
      "about.values.calm.title": "Mise au Point Calme",
      "about.values.intentionality.desc": "Éliminer le travail inutile pour se concentrer sur ce qui compte.",
      "about.values.intentionality.title": "Intentionnalité",
      "about.values.reflection.desc": "Faire une pause pour examiner les progrès grâce à des vérifications intégrées.",
      "about.values.reflection.title": "Réflexion",
      "about.values.title": "Nos Principes de Conception",
      "aiChat.commit.error": "Échec de la sauvegarde des éléments.",
      "aiChat.commit.success": "Ajout de {{items}} éléments à votre système.",
      "aiChat.continue.hint": "Répondez pour continuer le fil. ⌘ + Entrée pour envoyer.",
      "aiChat.continue.placeholder": "Répondez à la question ci-dessus ou ajoutez plus...",
      "aiChat.empty": "Je n'ai rien trouvé à ajouter. Essayez d'être plus spécifique sur vos objectifs, vos tâches ou qui vous voulez être.",
      "aiChat.extract.error": "L'IA n'a pas pu traiter cela. Réessayer ?",
      "aiChat.fab.label": "Agent Align",
      "aiChat.hint": "⌘ + Entrée pour envoyer. Appuyez sur le micro pour parler.",
      "aiChat.listening": "Écoute en cours... parlez naturellement, je m'en occupe.",
      "aiChat.panel.close": "Fermer",
      "aiChat.placeholder.examples.0": "Dites-moi ce que vous avez en tête — objectifs, tâches, qui vous voulez être...",
      "aiChat.placeholder.examples.1": "Essayer : ",
      "aiChat.placeholder.examples.2": "Essayer : ",
      "aiChat.placeholder.examples.3": "Essayer : ",
      "aiChat.reflections": "Réflexions",
      "aiChat.review.commit": "Ajouter à mon système",
      "aiChat.review.followup": "Suivi",
      "aiChat.review.nothingSelected": "Sélectionnez au moins un élément à ajouter.",
      "aiChat.review.title": "Revoir ce que j'ai trouvé",
      "aiChat.thread.reset": "Recommencer",
      "aiChat.voice.error": "Échec de la saisie vocale.",
      "aiChat.voice.tooltip": "Parler au lieu d'écrire",
      "aiChat.voice.unsupported": "La saisie vocale n'est pas prise en charge par ce navigateur.",
      "analytics.being.label": "Être",
      "analytics.being.subtitle": "Identités et Valeurs",
      "analytics.motivation.high": "Vous faites des progrès incroyables. Continuez à aligner vos actions avec votre vision.",
      "analytics.motivation.low": "Le voyage commence par un seul pas. Commencez aujourd'hui.",
      "analytics.motivation.medium": "Chaque petite action vous rapproche de qui vous voulez devenir.",
      "analytics.reflections": "Réflexions",
      "analytics.reflections.entries": "Entrées de journal",
      "analytics.streaks.active": "Séries Actives",
      "analytics.streaks.longest": "Plus longue: {{count}} jours",
      "analytics.subtitle": "Suivez votre voyage de l'action à l'identité",
      "analytics.tasks.completed": "Tâches Complétées",
      "analytics.tasks.rate": "{{rate}}% taux de réussite",
      "analytics.title": "Vos Progrès",
      "analytics.todo.label": "À Faire",
      "analytics.todo.subtitle": "Actions et Tâches",
      "analytics.want.label": "Vouloir",
      "analytics.want.subtitle": "Objectifs et Désirs",
      "analytics.wants.completed": "{{count}} complétés",
      "analytics.wants.progress": "Progrès des Désirs",
      "auth.email": "Email",
      "auth.google": "Continuer avec Google",
      "auth.loading": "Veuillez patienter...",
      "auth.loading.google": "Connexion...",
      "auth.loading.login": "Connexion en cours...",
      "auth.loading.signup": "Création du compte...",
      "auth.login": "Bienvenue",
      "auth.name": "Nom",
      "auth.or": "Ou",
      "auth.password": "Mot de passe",
      "auth.signup": "Créer un Compte",
      "auth.submit.login": "Se Connecter",
      "auth.submit.signup": "Créer un Compte",
      "auth.toggle.login": "Vous n'avez pas de compte? Inscrivez-vous",
      "auth.toggle.signup": "Vous avez déjà un compte? Connectez-vous",
      "auth.verify.backToHome": "Retour à l'accueil",
      "auth.verify.error": "Échec de la vérification. Le lien a peut-être expiré ou est invalide.",
      "auth.verify.errorTitle": "Échec de la vérification",
      "auth.verify.goToLogin": "Aller à la page de connexion",
      "auth.verify.needed": "Veuillez vérifier votre adresse e-mail avant de vous connecter.",
      "auth.verify.noToken": "Aucun jeton de vérification fourni.",
      "auth.verify.resend": "Renvoyer l'e-mail",
      "auth.verify.resentBody": "Si un compte existe pour cet e-mail, un nouveau lien de vérification a été envoyé.",
      "auth.verify.successBody": "Votre e-mail a été vérifié avec succès. Vous pouvez maintenant vous connecter.",
      "auth.verify.successTitle": "Compte vérifié !",
      "auth.verify.verifyingBody": "Veuillez patienter pendant que nous confirmons votre adresse e-mail...",
      "auth.verify.verifyingTitle": "Vérification de l'e-mail",
      "being.days": "jours",
      "being.description.placeholder": "Décrivez cet aspect de vous-même...",
      "being.empty": "Qui devenez-vous?",
      "being.practice": "Pratiquer Aujourd'hui",
      "being.streak": "Série",
      "being.title.placeholder": "Qui devenez-vous?",
      "being.type.habit": "Habitude",
      "being.type.identity": "Identité",
      "being.type.value": "Valeur",
      "corporate.firstTime.cta": "Créer un espace",
      "corporate.firstTime.subtitle": "Un espace de travail vous permet d'aligner une équipe ou une famille autour d'une vision, d'objectifs et de résultats clés partagés.",
      "corporate.firstTime.title": "Configurez votre premier espace",
      "corporate.goal.createError": "Impossible d'ajouter.",
      "corporate.goal.created": "Ajouté.",
      "corporate.goal.deleteConfirm": "Supprimer cet objectif ? Les sous-éléments associés seront également retirés.",
      "corporate.goal.deleteError": "Impossible de supprimer.",
      "corporate.goal.deleted": "Supprimé.",
      "corporate.goal.progress": "Progression",
      "corporate.goal.updateError": "Impossible de mettre à jour la progression.",
      "corporate.goals.fetchError": "Impossible de charger les objectifs.",
      "corporate.kr.add": "Ajouter un résultat clé",
      "corporate.kr.descPlaceholder": "Contexte facultatif.",
      "corporate.kr.titlePlaceholder": "Quel résultat mesurable prouve l'OKR ?",
      "corporate.level.kr": "Résultat clé",
      "corporate.level.okr": "OKR",
      "corporate.level.vision": "Vision",
      "corporate.loading": "Chargement de vos espaces...",
      "corporate.okr.add": "Ajouter un OKR",
      "corporate.okr.descPlaceholder": "Contexte facultatif.",
      "corporate.okr.titlePlaceholder": "Quel objectif sert cette vision ?",
      "corporate.type.corporate": "Entreprise",
      "corporate.type.corporateDesc": "Équipe ou org. Vision en cascade → OKRs → KRs.",
      "corporate.type.family": "Famille",
      "corporate.type.familyDesc": "Foyer. Valeurs partagées et thèmes annuels.",
      "corporate.vision.add": "Ajouter une vision",
      "corporate.vision.descPlaceholder": "Contexte facultatif, le pourquoi.",
      "corporate.vision.empty": "Aucune vision définie. Commencez par une déclaration de ce que cet espace cherche à accomplir.",
      "corporate.vision.titlePlaceholder": "Qu'est-ce que cet espace doit accomplir ?",
      "corporate.workspace.create": "Créer",
      "corporate.workspace.createError": "Impossible de créer l'espace.",
      "corporate.workspace.created": "Espace de travail créé.",
      "corporate.workspace.descLabel": "Description (facultatif)",
      "corporate.workspace.descPlaceholder": "Pourquoi cet espace de travail existe-t-il ?",
      "corporate.workspace.nameLabel": "Nom",
      "corporate.workspace.namePlaceholder": "ex. Acme Marketing, La Famille Martin",
      "corporate.workspace.new": "Nouvel espace de travail",
      "corporate.workspace.newSubtitle": "Donnez-lui un nom pour commencer à structurer votre vision en action.",
      "corporate.workspace.newTitle": "Créer un espace de travail",
      "corporate.workspace.typeLabel": "Type",
      "corporate.workspaces.fetchError": "Impossible de charger vos espaces de travail.",
      "family.cat.annual_themes.contentPlaceholder": "À quoi ressemble ce thème ? Qu'est-ce qui le prouverait en fin d'année ?",
      "family.cat.annual_themes.empty": "Quel est le thème de cette année ? Choisissez-en un ou deux, pas dix.",
      "family.cat.annual_themes.tagline": "Les thèmes qui façonnent cette année. Un mot ou une phrase.",
      "family.cat.annual_themes.title": "Cette année",
      "family.cat.annual_themes.titlePlaceholder": "ex. L'année du grand air, L'année de l'écoute",
      "family.cat.dreams.contentPlaceholder": "Pourquoi ce rêve ? Qu'est-ce que cela ferait ?",
      "family.cat.dreams.empty": "Écrivez quelque chose que personne dans la famille n'a osé dire à haute voix.",
      "family.cat.dreams.tagline": "Les souhaits à plus long terme. Pas de date limite, pas de honte.",
      "family.cat.dreams.title": "Rêves",
      "family.cat.dreams.titlePlaceholder": "ex. Voyager en Nouvelle-Zélande, Construire une cabane dans les arbres",
      "family.cat.values.contentPlaceholder": "À quoi ressemble cette valeur en pratique pour nous ?",
      "family.cat.values.empty": "Aucune valeur enregistrée. Commencez par celle qui compte le plus.",
      "family.cat.values.tagline": "Ce que représente cette famille. Les non-négociables.",
      "family.cat.values.title": "Valeurs",
      "family.cat.values.titlePlaceholder": "ex. Honnêteté, Aventure, Présence",
      "family.createError": "Impossible d'ajouter cela.",
      "family.created": "Ajouté.",
      "family.deleteConfirm": "Retirer cet élément du tableau de vision ?",
      "family.deleteError": "Impossible de retirer.",
      "family.deleted": "Retiré.",
      "family.fetchError": "Impossible de charger le tableau de vision.",
      "family.loading": "Chargement du tableau...",
      "family.subtitle": "Tableau de vision familiale",
      "form.cancel": "Annuler",
      "form.create": "Créer",
      "invite.acceptCta": "Accepter l'invitation",
      "invite.acceptError": "Impossible d'accepter l'invitation.",
      "invite.acceptSuccess": "Vous avez rejoint {{workspace}}.",
      "invite.alreadyUsedBody": "Cette invitation a déjà été acceptée.",
      "invite.alreadyUsedTitle": "Invitation déjà utilisée",
      "invite.backToDashboard": "Retour au tableau de bord",
      "invite.backToHome": "Retour à l'accueil",
      "invite.errorTitle": "Invitation non disponible",
      "invite.expiredBody": "Demandez à la personne qui vous a invité d'envoyer un nouveau lien.",
      "invite.expiredTitle": "Invitation expirée",
      "invite.heading": "Rejoindre {{workspace}}",
      "invite.label": "Invitation",
      "invite.loadError": "Impossible de charger cette invitation.",
      "invite.redirecting": "Redirection vers votre espace...",
      "invite.signInToAccept": "Connectez-vous pour accepter",
      "invite.subheading": "Vous avez été invité en tant que {{role}} de {{workspace}}.",
      "invite.welcomeTitle": "Bienvenue dans {{workspace}}",
      "landing.cta": "Commencez Votre Voyage",
      "landing.description": "Plus que des tâches. Connectez ce que vous <1>faites</1> à ce que vous <3>voulez</3>, et à qui vous <5>devenez</5>.",
      "landing.tagline": "De l'Action à l'Identité",
      "landing.title": "Aligner",
      "layer.being": "Être",
      "layer.being.subtitle": "Identité et Valeurs",
      "layer.todo": "À Faire",
      "layer.todo.subtitle": "Actions d'aujourd'hui",
      "layer.want": "Vouloir",
      "layer.want.subtitle": "Objectifs et Désirs",
      "members.invite.copyFail": "Impossible de copier le lien.",
      "members.invite.copyLink": "Copier le lien d'invitation",
      "members.invite.emailPlaceholder": "nom@exemple.com",
      "members.invite.error": "Impossible d'envoyer l'invitation.",
      "members.invite.linkCopied": "Lien d'invitation copié dans le presse-papiers.",
      "members.invite.linkHint": "Un e-mail est envoyé si configuré. Le lien est copié automatiquement pour que vous puissiez le partager directement.",
      "members.invite.revoke": "Révoquer",
      "members.invite.revokeConfirm": "Révoquer cette invitation ? Le lien ne fonctionnera plus.",
      "members.invite.revokeError": "Impossible de révoquer l'invitation.",
      "members.invite.revoked": "Invitation révoquée.",
      "members.invite.send": "Envoyer",
      "members.invite.sent": "Invitation envoyée.",
      "members.invite.title": "Inviter un membre",
      "members.list.title": "Membres ({{count}})",
      "members.list.you": "vous",
      "members.loadError": "Impossible de charger les membres.",
      "members.loading": "Chargement des membres...",
      "members.pending.title": "Invitations en attente ({{count}})",
      "members.role.admin": "Administrateur",
      "members.role.manager": "Gestionnaire",
      "members.role.member": "Membre",
      "members.title": "Membres",
      "mode.corporate": "Entreprise",
      "mode.family": "Famille",
      "mode.personal": "Personnel",
      "nav.about": "À Propos",
      "nav.back": "Retour au Tableau de Bord",
      "nav.calendar": "Calendrier",
      "nav.dashboard": "Tableau de bord",
      "nav.help": "Aide",
      "nav.logout": "Déconnexion",
      "nav.progress": "Progrès",
      "nav.reflect": "Réfléchir",
      "reflection.empty": "Aucune réflexion pour l'instant. Commencez votre voyage ci-dessus!",
      "reflection.past": "Réflexions Passées",
      "reflection.placeholder": "Écrivez vos pensées ici...",
      "reflection.save": "Enregistrer la Réflexion",
      "reflection.saving": "Enregistrement...",
      "reflection.subtitle": "Prenez un moment pour faire une pause et réfléchir à votre parcours",
      "reflection.title": "Réflexion Quotidienne",
      "review.dismiss": "Masquer pour l'instant",
      "review.engage": "Y réfléchir",
      "review.label": "Bilan hebdomadaire",
      "review.skipWeek": "Passer cette semaine",
      "review.statsCompleted": "Vous avez complété {{done}} sur {{total}} actions alignées cette semaine",
      "toast.auth.error": "Échec de l'authentification",
      "toast.being.created": "Être créé",
      "toast.being.deleted": "Être supprimé",
      "toast.being.error": "Échec de la création de l'être",
      "toast.reflection.error": "Échec de l'enregistrement de la réflexion",
      "toast.reflection.saved": "Réflexion enregistrée",
      "toast.session.expired": "Session expirée. Veuillez vous reconnecter.",
      "toast.streak": "Série: {{count}} jours!",
      "toast.todo.created": "Tâche créée",
      "toast.todo.deleted": "Tâche supprimée",
      "toast.todo.error": "Échec de la création de la tâche",
      "toast.want.created": "Désir créé",
      "toast.want.deleted": "Désir supprimé",
      "toast.want.error": "Échec de la création du désir",
      "toast.welcome.login": "Bon retour!",
      "toast.welcome.signup": "Bienvenue sur Aligner!",
      "today.embody": "Incarner",
      "today.empty": "Rien de prévu pour aujourd'hui. Ajoutez une tâche ou demandez à l'assistant.",
      "today.label": "Aujourd'hui",
      "today.next": "Prochaines étapes",
      "todo.connect.being": "Connecter à un Être (facultatif)",
      "todo.connect.want": "Connecter à un Désir (facultatif)",
      "todo.description.placeholder": "Détails (facultatif)",
      "todo.empty": "Aucune tâche pour l'instant. Créez-en une pour commencer!",
      "todo.title.placeholder": "Que faut-il faire?",
      "tour.btn.done": "Terminer",
      "tour.btn.next": "Suivant",
      "tour.btn.prev": "Précédent",
      "tour.helpTooltip": "Aide Interactive",
      "tour.step1.desc": "Align vous aide à combler le fossé entre qui vous voulez être et ce que vous faites chaque jour. Nous vous avons lancé avec un essai gratuit de 14 jours d'Align Pro (avec accès illimité et coaching IA !). Faisons un tour rapide d'une minute pour voir comment cela fonctionne.",
      "tour.step1.title": "Bienvenue sur Align",
      "tour.step2.desc": "C'est la racine de votre cascade. Définissez qui vous voulez devenir ou quelles valeurs vous voulez pratiquer (ex: 'Développeur Senior' ou 'Coureur en bonne santé').",
      "tour.step2.title": "1. To Be (Identité & Valeurs)",
      "tour.step3.desc": "Fixez des objectifs concrets qui soutiennent vos identités. Par exemple, 'Maîtriser la conception de systèmes' soutient votre identité de développeur.",
      "tour.step3.title": "2. To Want (Objectifs & Désirs)",
      "tour.step4.desc": "Créez des tâches immédiates ici et liez-les à vos objectifs. Les barres de progression de vos objectifs se mettront à jour automatiquement lorsque vous cocherez ces tâches !",
      "tour.step4.title": "3. To Do (Actions d'aujourd'hui)",
      "tour.step5.desc": "Votre barre latérale montre votre identité de concentration pour aujourd'hui, votre bilan hebdomadaire et les 3 tâches prioritaires sur lesquelles vous concentrer ensuite.",
      "tour.step5.title": "Votre cockpit quotidien",
      "tour.step6.desc": "Parlez à votre coach IA ici. Écrivez des réflexions sur votre journée, et l'IA extraira et liera automatiquement de nouvelles identités, objectifs et tâches pour vous !",
      "tour.step6.title": "Réflexion & Coach IA",
      "tour.step7.desc": "Cliquez sur 'Calendar' (Calendrier) pour afficher et personnaliser votre emploi du temps quotidien, cliquez sur 'Reflect' (Réfléchir) pour écrire des entrées de journal et voir votre historique de réflexion, ou cliquez sur 'Progress' (Progrès) pour voir votre tableau de bord analytique et vos séries.",
      "tour.step7.title": "Planifier, Réfléchir & Suivre votre progrès",
      "tour.calendar.step1.desc": "Bienvenue dans votre calendrier. Ici, vous pouvez organiser vos activités quotidiennes dans un calendrier visuel.",
      "tour.calendar.step1.title": "Cockpit de Planification Journalière",
      "tour.calendar.step2.desc": "Déplacez-vous entre les jours pour planifier des tâches à l'avance ou passer en revue la façon dont vous avez passé vos journées passées.",
      "tour.calendar.step2.title": "Navigation par Date",
      "tour.calendar.step3.desc": "Ce panneau contient tous vos Êtres, Désirs et Tâches actifs qui n'ont pas encore été placés dans l'emploi du temps d'aujourd'hui.",
      "tour.calendar.step3.title": "Éléments non Planifiés",
      "tour.calendar.step4.desc": "Cliquez sur \"+ Ajouter un bloc à cette heure\" pour choisir une tâche dans votre liste non planifiée et bloquer du temps pour celle-ci.",
      "tour.calendar.step4.title": "Emploi du Temps Horaire",
      "tour.calendar.step5.desc": "Cliquez sur ce bouton pour basculer entre le Calendrier et votre Tableau de bord à trois colonnes.",
      "tour.calendar.step5.title": "Changer de Mode de Vue",
      "want.description.placeholder": "Pourquoi est-ce important pour vous?",
      "want.empty": "Pas d'objectifs encore. Que voulez-vous?",
      "want.progress": "Progrès",
      "want.title.placeholder": "Que voulez-vous?",
      "workspace.corporate.createCta": "Créer",
      "workspace.corporate.descPlaceholder": "Pourquoi cet espace de travail existe-t-il ?",
      "workspace.corporate.firstTime.cta": "Créer un espace",
      "workspace.corporate.firstTime.subtitle": "Un espace de travail pour votre équipe. Structurez la vision en OKRs et résultats clés. Invitez des collaborateurs quand vous êtes prêt.",
      "workspace.corporate.firstTime.title": "Configurez votre premier espace",
      "workspace.corporate.namePlaceholder": "ex. Acme Marketing, Équipe Ingénierie",
      "workspace.corporate.newOption": "Nouvel espace de travail",
      "workspace.corporate.newSubtitle": "Donnez-lui un nom pour commencer à structurer votre vision en action.",
      "workspace.corporate.newTitle": "Créer un espace de travail",
      "workspace.family.createCta": "Créer",
      "workspace.family.descPlaceholder": "Qu'est-ce qui tire cette famille vers l'avant ?",
      "workspace.family.firstTime.cta": "Créer un espace familial",
      "workspace.family.firstTime.subtitle": "Un espace partagé pour votre foyer. Capturez vos valeurs, vos thèmes de l'année et vos rêves à réaliser ensemble.",
      "workspace.family.firstTime.title": "Configurez votre espace familial",
      "workspace.family.namePlaceholder": "ex. La Famille Martin, Notre 2026",
      "workspace.family.newOption": "Nouvel espace familial",
      "workspace.family.newSubtitle": "Nommez-le d'après la famille ou le chapitre partagé. Vous pouvez être dans plus d'un.",
      "workspace.family.newTitle": "Créer un espace familial",
      "calendar.title": "Emploi du Temps",
      "calendar.loading": "Chargement de l'emploi du temps...",
      "calendar.continued": "Suite :",
      "calendar.until": "(jusqu'à {{time}})",
      "calendar.addBlock": "+ Ajouter un bloc à cette heure",
      "calendar.addBlockPrompt": "Ajouter un bloc à cette heure",
      "calendar.editSchedule": "Modifier l'Emploi du Temps : {{title}}",
      "calendar.scheduleTitle": "Emploi du Temps : {{title}}",
      "calendar.startTime": "HEURE DE DÉBUT",
      "calendar.duration": "DURÉE",
      "calendar.itemType": "TYPE D'ÉLÉMENT",
      "calendar.description": "DESCRIPTION",
      "calendar.unschedule": "Déprogrammer",
      "calendar.cancel": "Annuler",
      "calendar.update": "Mettre à jour",
      "calendar.schedule": "Programmer",
      "calendar.hours": "Heures",
      "calendar.mins": "Minutes",
      "calendar.custom": "Personnalisé...",
      "calendar.unscheduledItems": "Éléments non Programmés",
      "calendar.beings": "Être (Identités & Habitudes)",
      "calendar.wants": "Vouloir (Objectifs & Désirs)",
      "calendar.todos": "Faire (Actions d'Aujourd'hui)",
      "calendar.noneUnscheduled": "Aucun non programmé",
      "welcome.success": "Bienvenue à bord ! Votre espace de travail est prêt.",
      "welcome.error": "Échec de l'initialisation de l'espace de travail. Veuillez réessayer.",
      "welcome.trial.title": "Bienvenue sur Align Pro",
      "welcome.trial.subtitle": "Votre essai gratuit de 14 jours est actif. Sélectionnez un domaine de mise au point pour initier votre première cascade d'objectifs.",
      "welcome.focus.section_title": "Choisissez votre principal domaine de mise au point :",
      "welcome.focus.health.title": "Santé & Vitalité",
      "welcome.focus.health.desc": "Développez votre énergie physique, vos saines habitudes et faites de l'exercice quotidiennement.",
      "welcome.focus.career.title": "Carrière & Concentration",
      "welcome.focus.career.desc": "Améliorez votre productivité, atteignez vos objectifs de projet et planifiez votre travail.",
      "welcome.focus.mindfulness.title": "Pleine Conscience & Présence",
      "welcome.focus.mindfulness.desc": "Cultivez la réflexion quotidienne, réduisez le temps d'écran et restez présent.",
      "welcome.focus.blank.title": "Explorer Librement (Page blanche)",
      "welcome.focus.blank.desc": "Partez d'une page blanche. Créez votre propre cascade personnalisée à partir de zéro.",
      "welcome.trial.highlight": "Essai Pro Activé",
      "welcome.trial.highlight_desc": "Vous disposez d'un accès complet au coaching IA en direct, aux espaces de travail familiaux/d'entreprise et à des objectifs illimités. Aucune carte de crédit requise.",
      "welcome.loading": "Initialisation de l'espace de travail...",
      "welcome.trial.cta": "Entrer dans mon espace de travail",
      "welcome.trial.guarantee": "Pas de prélèvements automatiques.",
      "tour.step_stalled.title": "Relance d'Objectifs en Panne",
      "tour.step_stalled.desc_pro": "Lorsque les objectifs perdent leur élan, cette carte vous aide à les archiver ou à réfléchir avec votre coach IA pour vous débloquer.",
      "tour.step_stalled.desc_starter": "Lorsque les objectifs perdent leur élan, cette carte vous aide à les archiver ou à ajouter une petite action immédiate pour vous débloquer.",
      "dialog.delete.being.title": "Supprimer cet Être ?",
      "dialog.delete.being.desc": "Tous les objectifs et tâches connectés seront supprimés avec cette identité.",
      "dialog.delete.want.title": "Supprimer cet Objectif ?",
      "dialog.delete.want.desc": "Toutes les tâches connectées seront supprimées avec cet objectif.",
      "dialog.delete.todo.title": "Supprimer cette Tâche ?",
      "dialog.delete.todo.desc": "Cette tâche sera définitivement supprimée.",
      "dialog.delete.confirm": "Supprimer",
      "dialog.delete.cancel": "Annuler"
    }
  },
  de: {
    translation: {
      "about.back": "Zurück",
      "about.framework.be.desc": "Konzentriert sich auf Ihre Grundwerte, Gewohnheiten und Identität.",
      "about.framework.be.title": "Sein (Identität)",
      "about.framework.do.desc": "Konzentriert sich auf Ihre täglichen Aufgaben und Checklisten.",
      "about.framework.do.title": "Tun (Aktionen)",
      "about.framework.title": "Das Kern-Framework",
      "about.framework.want.desc": "Erfasst Ihre konkreten Ziele und Bestrebungen, die Ihre Identität unterstützen.",
      "about.framework.want.title": "Wollen (Ziele)",
      "about.modes.corporate.desc": "Für die Teamausrichtung, Unternehmensvisionen und kaskadierende OKRs.",
      "about.modes.corporate.title": "Unternehmensbereich",
      "about.modes.family.desc": "Für gemeinsame Familienwerte, Einladungen und Familien-Visionboards.",
      "about.modes.family.title": "Familienbereich",
      "about.modes.personal.desc": "Für privates Gewohnheitstracking, Serien und tägliche Reflexionen.",
      "about.modes.personal.title": "Persönlicher Bereich",
      "about.modes.title": "Ein Framework, drei Arbeitsbereiche",
      "about.philosophy.body": "Align soll Ihnen helfen, bewusst zu leben, indem es Ihre täglichen Aufgaben mit Ihrer langfristigen Lebensvision und dem, wer Sie werden, verbindet.",
      "about.philosophy.title": "Unsere Philosophie",
      "about.tagline": "Von der Aktion zur Identität",
      "about.title": "Über Align",
      "about.values.calm.desc": "Eine minimalistische Benutzeroberfläche zur Reduzierung des digitalen Rauschens.",
      "about.values.calm.title": "Ruhiger Fokus",
      "about.values.intentionality.desc": "Vermeidung von unnötiger Beschäftigung, um sich auf das Wesentliche zu konzentrieren.",
      "about.values.intentionality.title": "Intentionalität",
      "about.values.reflection.desc": "Innehalten, um Fortschritte durch integrierte Überprüfungen zu bewerten.",
      "about.values.reflection.title": "Reflexion",
      "about.values.title": "Unsere Designprinzipien",
      "aiChat.commit.error": "Fehler beim Speichern der Elemente.",
      "aiChat.commit.success": "{{items}} Elemente zu Ihrem System hinzugefügt.",
      "aiChat.continue.hint": "Antworten, um den Thread fortzusetzen. ⌘ + Eingabetaste zum Senden.",
      "aiChat.continue.placeholder": "Beantworten Sie die obige Frage oder fügen Sie mehr hinzu...",
      "aiChat.empty": "Ich habe nichts zum Hinzufügen gefunden. Versuchen Sie, Ihre Ziele, Aufgaben oder Ihre gewünschte Identität genauer zu beschreiben.",
      "aiChat.extract.error": "Die KI konnte das nicht verarbeiten. Erneut versuchen?",
      "aiChat.fab.label": "Align-Agent",
      "aiChat.hint": "⌘ + Eingabetaste zum Senden. Tippen Sie auf das Mikrofon, um zu sprechen.",
      "aiChat.listening": "Zuhören... sprechen Sie ganz natürlich, ich kümmere mich darum.",
      "aiChat.panel.close": "Schließen",
      "aiChat.placeholder.examples.0": "Erzählen Sie mir, was Sie beschäftigt — Ziele, Aufgaben, Identität...",
      "aiChat.placeholder.examples.1": "Probieren Sie: ",
      "aiChat.placeholder.examples.2": "Probieren Sie: ",
      "aiChat.placeholder.examples.3": "Probieren Sie: ",
      "aiChat.reflections": "Reflexionen",
      "aiChat.review.commit": "Zu meinem System hinzufügen",
      "aiChat.review.followup": "Nachbereitung",
      "aiChat.review.nothingSelected": "Wählen Sie mindestens ein Element aus, um es hinzuzufügen.",
      "aiChat.review.title": "Überprüfen, was gefunden wurde",
      "aiChat.thread.reset": "Neu starten",
      "aiChat.voice.error": "Spracheingabe fehlgeschlagen.",
      "aiChat.voice.tooltip": "Sprechen statt tippen",
      "aiChat.voice.unsupported": "Spracheingabe wird von diesem Browser nicht unterstützt.",
      "analytics.being.label": "Sein",
      "analytics.being.subtitle": "Identitäten & Werte",
      "analytics.motivation.high": "Sie machen unglaubliche Fortschritte. Richten Sie Ihre Handlungen weiter an Ihrer Vision aus.",
      "analytics.motivation.low": "Die Reise beginnt mit einem einzigen Schritt. Beginnen Sie heute.",
      "analytics.motivation.medium": "Jede kleine Aktion bringt Sie näher zu dem, wer Sie werden wollen.",
      "analytics.reflections": "Reflexionen",
      "analytics.reflections.entries": "Tagebucheinträge",
      "analytics.streaks.active": "Aktive Serien",
      "analytics.streaks.longest": "Längste: {{count}} Tage",
      "analytics.subtitle": "Verfolgen Sie Ihre Reise von der Aktion zur Identität",
      "analytics.tasks.completed": "Erledigte Aufgaben",
      "analytics.tasks.rate": "{{rate}}% Abschlussrate",
      "analytics.title": "Ihr Fortschritt",
      "analytics.todo.label": "Zu Tun",
      "analytics.todo.subtitle": "Aktionen & Aufgaben",
      "analytics.want.label": "Wollen",
      "analytics.want.subtitle": "Ziele & Wünsche",
      "analytics.wants.completed": "{{count}} abgeschlossen",
      "analytics.wants.progress": "Wunsch-Fortschritt",
      "auth.email": "E-Mail",
      "auth.google": "Mit Google fortfahren",
      "auth.loading": "Bitte warten...",
      "auth.loading.google": "Verbindung wird hergestellt...",
      "auth.loading.login": "Anmeldung läuft...",
      "auth.loading.signup": "Konto wird erstellt...",
      "auth.login": "Willkommen Zurück",
      "auth.name": "Name",
      "auth.or": "Oder",
      "auth.password": "Passwort",
      "auth.signup": "Konto Erstellen",
      "auth.submit.login": "Anmelden",
      "auth.submit.signup": "Konto Erstellen",
      "auth.toggle.login": "Kein Konto? Registrieren",
      "auth.toggle.signup": "Haben Sie bereits ein Konto? Anmelden",
      "auth.verify.backToHome": "Zurück zur Startseite",
      "auth.verify.error": "Verifizierung fehlgeschlagen. Der Link ist möglicherweise abgelaufen oder ungültig.",
      "auth.verify.errorTitle": "Verifizierung fehlgeschlagen",
      "auth.verify.goToLogin": "Zur Anmeldung gehen",
      "auth.verify.needed": "Bitte verifizieren Sie Ihre E-Mail-Adresse, bevor Sie sich anmelden.",
      "auth.verify.noToken": "Kein Verifizierungstoken bereitgestellt.",
      "auth.verify.resend": "E-Mail erneut senden",
      "auth.verify.resentBody": "Wenn ein Konto für diese E-Mail existiert, wurde ein neuer Link gesendet.",
      "auth.verify.successBody": "Ihre E-Mail-Adresse wurde erfolgreich verifiziert. Sie können sich jetzt anmelden.",
      "auth.verify.successTitle": "Konto verifiziert!",
      "auth.verify.verifyingBody": "Bitte warten Sie, während wir Ihre E-Mail-Adresse bestätigen...",
      "auth.verify.verifyingTitle": "E-Mail wird verifiziert",
      "being.days": "Tage",
      "being.description.placeholder": "Beschreiben Sie diesen Aspekt von sich selbst...",
      "being.empty": "Wer werden Sie?",
      "being.practice": "Heute Üben",
      "being.streak": "Serie",
      "being.title.placeholder": "Wer werden Sie?",
      "being.type.habit": "Gewohnheit",
      "being.type.identity": "Identität",
      "being.type.value": "Wert",
      "corporate.firstTime.cta": "Bereich erstellen",
      "corporate.firstTime.subtitle": "In einem Workspace können Sie ein Team oder eine Familie auf eine gemeinsame Vision, Ziele und Key Results ausrichten.",
      "corporate.firstTime.title": "Richten Sie Ihren ersten Workspace ein",
      "corporate.goal.createError": "Konnte nicht hinzugefügt werden.",
      "corporate.goal.created": "Hinzugefügt.",
      "corporate.goal.deleteConfirm": "Diesen Ziel entfernen? Alle verknüpften Unterelemente werden ebenfalls gelöscht.",
      "corporate.goal.deleteError": "Konnte nicht gelöscht werden.",
      "corporate.goal.deleted": "Gelöscht.",
      "corporate.goal.progress": "Fortschritt",
      "corporate.goal.updateError": "Fortschritt konnte nicht aktualisiert werden.",
      "corporate.goals.fetchError": "Ziele konnten nicht geladen werden.",
      "corporate.kr.add": "Key Result hinzufügen",
      "corporate.kr.descPlaceholder": "Optionaler Kontext.",
      "corporate.kr.titlePlaceholder": "Welches messbare Ergebnis beweist den OKR?",
      "corporate.level.kr": "Key Result",
      "corporate.level.okr": "OKR",
      "corporate.level.vision": "Vision",
      "corporate.loading": "Arbeitsbereiche werden geladen...",
      "corporate.okr.add": "OKR hinzufügen",
      "corporate.okr.descPlaceholder": "Optionaler Kontext.",
      "corporate.okr.titlePlaceholder": "Welches Ziel dient dieser Vision?",
      "corporate.type.corporate": "Unternehmen",
      "corporate.type.corporateDesc": "Team oder Org. Kaskadierende Vision → OKRs → KRs.",
      "corporate.type.family": "Familie",
      "corporate.type.familyDesc": "Haushalt. Gemeinsame Werte und Jahresthemen.",
      "corporate.vision.add": "Vision hinzufügen",
      "corporate.vision.descPlaceholder": "Optionaler Kontext, das Warum.",
      "corporate.vision.empty": "Noch keine Vision festgelegt. Starten Sie mit einer Aussage über das Ziel dieses Workspace.",
      "corporate.vision.titlePlaceholder": "Was soll dieser Workspace erreichen?",
      "corporate.workspace.create": "Erstellen",
      "corporate.workspace.createError": "Workspace konnte nicht erstellt werden.",
      "corporate.workspace.created": "Workspace erstellt.",
      "corporate.workspace.descLabel": "Beschreibung (optional)",
      "corporate.workspace.descPlaceholder": "Wozu existiert dieser Workspace?",
      "corporate.workspace.nameLabel": "Name",
      "corporate.workspace.namePlaceholder": "z.B. Acme Marketing, Familie Müller",
      "corporate.workspace.new": "Neuer Workspace",
      "corporate.workspace.newSubtitle": "Geben Sie ihm einen Namen, um mit der kaskadierenden Vision zu beginnen.",
      "corporate.workspace.newTitle": "Einen Workspace erstellen",
      "corporate.workspace.typeLabel": "Typ",
      "corporate.workspaces.fetchError": "Arbeitsbereiche konnten nicht geladen werden.",
      "family.cat.annual_themes.contentPlaceholder": "Wie sieht dieses Thema aus? Was würde es am Jahresende beweisen?",
      "family.cat.annual_themes.empty": "Was ist das Thema dieses Jahres? Wählen Sie ein oder zwei, nicht zehn.",
      "family.cat.annual_themes.tagline": "Die Themen, die dieses Jahr prägen. Ein Wort oder ein Satz.",
      "family.cat.annual_themes.title": "Dieses Jahr",
      "family.cat.annual_themes.titlePlaceholder": "z.B. Das Jahr im Freien, Jahr des Zuhörens",
      "family.cat.dreams.contentPlaceholder": "Warum dieser Traum? Wie würde es sich anfühlen?",
      "family.cat.dreams.empty": "Schreiben Sie etwas auf, das niemand in der Familie laut auszusprechen gewagt hat.",
      "family.cat.dreams.tagline": "Die längerfristigen Träume. Keine Fristen, keine Scham.",
      "family.cat.dreams.title": "Träume",
      "family.cat.dreams.titlePlaceholder": "z.B. Reise durch Neuseeland, Ein Baumhaus bauen",
      "family.cat.values.contentPlaceholder": "Wie sieht dieser Wert für uns in der Praxis aus?",
      "family.cat.values.empty": "Noch keine Werte eingetragen. Beginnen Sie mit dem wichtigsten.",
      "family.cat.values.tagline": "Wofür diese Familie steht. Die unverhandelbaren Dinge.",
      "family.cat.values.title": "Werte",
      "family.cat.values.titlePlaceholder": "z.B. Ehrlichkeit, Abenteuer, Präsenz",
      "family.createError": "Konnte nicht hinzugefügt werden.",
      "family.created": "Hinzugefügt.",
      "family.deleteConfirm": "Dieses Element vom Vision Board entfernen?",
      "family.deleteError": "Konnte nicht entfernt werden.",
      "family.deleted": "Entfernt.",
      "family.fetchError": "Vision Board konnte nicht geladen werden.",
      "family.loading": "Board wird geladen...",
      "family.subtitle": "Familien Vision Board",
      "form.cancel": "Abbrechen",
      "form.create": "Erstellen",
      "invite.acceptCta": "Einladung annehmen",
      "invite.acceptError": "Einladung konnte nicht angenommen werden.",
      "invite.acceptSuccess": "Erfolgreich {{workspace}} beigetreten.",
      "invite.alreadyUsedBody": "Diese Einladung wurde bereits angenommen.",
      "invite.alreadyUsedTitle": "Einladung bereits verwendet",
      "invite.backToDashboard": "Zurück zum Dashboard",
      "invite.backToHome": "Zurück zur Startseite",
      "invite.errorTitle": "Einladung nicht verfügbar",
      "invite.expiredBody": "Bitten Sie die Person, die Sie eingeladen hat, einen neuen Link zu senden.",
      "invite.expiredTitle": "Einladung abgelaufen",
      "invite.heading": "Beitreten zu {{workspace}}",
      "invite.label": "Einladung",
      "invite.loadError": "Einladung konnte nicht geladen werden.",
      "invite.redirecting": "Weiterleitung zum Arbeitsbereich...",
      "invite.signInToAccept": "Anmelden, um anzunehmen",
      "invite.subheading": "Sie wurden als {{role}} von {{workspace}} eingeladen.",
      "invite.welcomeTitle": "Willkommen bei {{workspace}}",
      "landing.cta": "Beginnen Sie Ihre Reise",
      "landing.description": "Mehr als Aufgaben. Verbinden Sie, was Sie <1>tun</1>, mit dem, was Sie <3>wollen</3>, und wer Sie <5>werden</5>.",
      "landing.tagline": "Von Aktion zur Identität",
      "landing.title": "Ausrichten",
      "layer.being": "Sein",
      "layer.being.subtitle": "Identität und Werte",
      "layer.todo": "Zu Tun",
      "layer.todo.subtitle": "Heutige Aktionen",
      "layer.want": "Wollen",
      "layer.want.subtitle": "Ziele und Wünsche",
      "members.invite.copyFail": "Link konnte nicht kopiert werden.",
      "members.invite.copyLink": "Einladungslink kopieren",
      "members.invite.emailPlaceholder": "name@example.com",
      "members.invite.error": "Einladung konnte nicht gesendet werden.",
      "members.invite.linkCopied": "Einladungslink in die Zwischenablage kopiert.",
      "members.invite.linkHint": "E-Mail wird gesendet, falls konfiguriert. Der Link wird automatisch kopiert, damit Sie ihn teilen können.",
      "members.invite.revoke": "Widerrufen",
      "members.invite.revokeConfirm": "Diese Einladung widerrufen? Der Link wird ungültig.",
      "members.invite.revokeError": "Einladung konnte nicht widerrufen werden.",
      "members.invite.revoked": "Einladung widerrufen.",
      "members.invite.send": "Senden",
      "members.invite.sent": "Einladung gesendet.",
      "members.invite.title": "Teammitglied einladen",
      "members.list.title": "Mitglieder ({{count}})",
      "members.list.you": "Sie",
      "members.loadError": "Mitglieder konnten nicht geladen werden.",
      "members.loading": "Mitglieder werden geladen...",
      "members.pending.title": "Ausstehende Einladungen ({{count}})",
      "members.role.admin": "Admin",
      "members.role.manager": "Manager",
      "members.role.member": "Mitglied",
      "members.title": "Mitglieder",
      "mode.corporate": "Unternehmen",
      "mode.family": "Familie",
      "mode.personal": "Persönlich",
      "nav.about": "Über uns",
      "nav.back": "Zurück zum Dashboard",
      "nav.calendar": "Kalender",
      "nav.dashboard": "Dashboard",
      "nav.help": "Hilfe",
      "nav.logout": "Abmelden",
      "nav.progress": "Fortschritt",
      "nav.reflect": "Reflektieren",
      "reflection.empty": "Noch keine Reflexionen. Beginnen Sie Ihre Reise oben!",
      "reflection.past": "Vergangene Reflexionen",
      "reflection.placeholder": "Schreiben Sie Ihre Gedanken hier...",
      "reflection.save": "Reflexion Speichern",
      "reflection.saving": "Wird gespeichert...",
      "reflection.subtitle": "Nehmen Sie sich einen Moment Zeit, um über Ihre Reise nachzudenken",
      "reflection.title": "Tägliche Reflexion",
      "review.dismiss": "Vorerst ausblenden",
      "review.engage": "Darüber nachdenken",
      "review.label": "Wöchentlicher Check-in",
      "review.skipWeek": "Diese Woche überspringen",
      "review.statsCompleted": "Du hast diese Woche {{done}} von {{total}} ausgerichteten Aktionen abgeschlossen",
      "toast.auth.error": "Authentifizierung fehlgeschlagen",
      "toast.being.created": "Sein erstellt",
      "toast.being.deleted": "Sein gelöscht",
      "toast.being.error": "Fehler beim Erstellen des Seins",
      "toast.reflection.error": "Fehler beim Speichern der Reflexion",
      "toast.reflection.saved": "Reflexion gespeichert",
      "toast.session.expired": "Sitzung abgelaufen. Bitte melden Sie sich erneut an.",
      "toast.streak": "Serie: {{count}} Tage!",
      "toast.todo.created": "Aufgabe erstellt",
      "toast.todo.deleted": "Aufgabe gelöscht",
      "toast.todo.error": "Fehler beim Erstellen der Aufgabe",
      "toast.want.created": "Wunsch erstellt",
      "toast.want.deleted": "Wunsch gelöscht",
      "toast.want.error": "Fehler beim Erstellen des Wunsches",
      "toast.welcome.login": "Willkommen zurück!",
      "toast.welcome.signup": "Willkommen bei Ausrichten!",
      "today.embody": "Verkörpern",
      "today.empty": "Nichts auf dem Zettel. Füge Aufgaben hinzu oder frage die KI.",
      "today.label": "Heute",
      "today.next": "Nächste Schritte",
      "todo.connect.being": "Mit einem Sein verbinden (optional)",
      "todo.connect.want": "Mit einem Wunsch verbinden (optional)",
      "todo.description.placeholder": "Details (optional)",
      "todo.empty": "Noch keine Aufgaben. Erstellen Sie eine!",
      "todo.title.placeholder": "Was muss getan werden?",
      "tour.btn.done": "Fertig",
      "tour.btn.next": "Weiter",
      "tour.btn.prev": "Zurück",
      "tour.helpTooltip": "Hilfe-Tour",
      "tour.step1.desc": "Align hilft Ihnen, die Lücke zwischen dem, wer Sie sein möchten, und dem, was Sie täglich tun, zu schließen. Lassen Sie uns einen kurzen 1-minütigen Rundgang machen, um zu sehen, wie es funktioniert.",
      "tour.step1.title": "Willkommen bei Align",
      "tour.step2.desc": "Dies ist die Wurzel Ihrer Kaskade. Definieren Sie, wer Sie werden möchten oder welche Werte Sie praktizieren möchten (z.B. 'Senior Software Entwickler' oder 'Gesunder Läufer').",
      "tour.step2.title": "1. To Be (Identität & Werte)",
      "tour.step3.desc": "Setzen Sie konkrete Ziele, die Ihre Identitäten unterstützen. Zum Beispiel unterstützt 'Verteilten Systementwurf meistern' Ihre Entwickleridentität.",
      "tour.step3.title": "2. To Want (Ziele & Wünsche)",
      "tour.step4.desc": "Erstellen Sie hier sofortige Aufgaben und verknüpfen Sie diese mit Ihren Zielen. Die Fortschrittsbalken Ihrer Ziele werden automatisch aktualisiert, wenn Sie diese Aufgaben abhacken!",
      "tour.step4.title": "3. To Do (Heutige Aktionen)",
      "tour.step5.desc": "Ihre Seitenleiste zeigt Ihre Fokus-Identität für heute, Ihren wöchentlichen Check-in und die 3 wichtigsten Aufgaben, auf die Sie sich als Nächstes konzentrieren sollten.",
      "tour.step5.title": "Ihr tägliches Cockpit",
      "tour.step6.desc": "Sprechen Sie hier mit Ihrem KI-Coach. Schreiben Sie Reflexionen über Ihren Tag, und die KI wird automatisch neue Identitäten, Ziele und Aufgaben für Sie extrahieren und verknüpfen!",
      "tour.step6.title": "KI Reflexion & Coach",
      "tour.step7.desc": "Klicken Sie auf 'Calendar' (Kalender), um Ihren täglichen Zeitplan anzuzeigen und anzupassen, klicken Sie auf 'Reflect' (Reflektieren), um tägliche Journal-Einträge zu schreiben und Ihren Reflexionsverlauf anzuzeigen, oder klicken Sie auf 'Progress' (Fortschritt), um Ihr visuelles Analyse-Dashboard und Ihre Streaks anzuzeigen.",
      "tour.step7.title": "Planen, Reflektieren & Fortschritt verfolgen",
      "tour.calendar.step1.desc": "Willkommen in Ihrem Kalender. Hier können Sie Ihre täglichen Aktivitäten in einer visuellen Zeitleiste organisieren.",
      "tour.calendar.step1.title": "Tagesplaner-Cockpit",
      "tour.calendar.step2.desc": "Navigieren Sie zwischen den Tagen, um Aufgaben im Voraus zu planen oder zu überprüfen, wie Sie die vergangenen Tage verbracht haben.",
      "tour.calendar.step2.title": "Datumsnavigation",
      "tour.calendar.step3.desc": "Dieses Panel enthält alle Ihre aktiven Identitäten, Ziele und Aufgaben, die noch nicht im heutigen Zeitplan eingetragen sind.",
      "tour.calendar.step3.title": "Ungeplante Aufgaben",
      "tour.calendar.step4.desc": "Klicken Sie auf \"+ Block zu dieser Zeit hinzufügen\", um eine Aufgabe aus Ihrer ungeplanten Liste auszuwählen und Zeit dafür zu reservieren.",
      "tour.calendar.step4.title": "Stündliche Zeitleiste",
      "tour.calendar.step5.desc": "Klicken Sie auf diese Schaltfläche, um zwischen dem Kalender und Ihrem dreispaltigen Dashboard hin- und herzuwechseln.",
      "tour.calendar.step5.title": "Ansichtsmodus wechseln",
      "want.description.placeholder": "Warum ist Ihnen das wichtig?",
      "want.empty": "Noch keine Ziele. Was wollen Sie?",
      "want.progress": "Fortschritt",
      "want.title.placeholder": "Was wollen Sie?",
      "workspace.corporate.createCta": "Erstellen",
      "workspace.corporate.descPlaceholder": "Wozu existiert dieser Workspace?",
      "workspace.corporate.firstTime.cta": "Workspace erstellen",
      "workspace.corporate.firstTime.subtitle": "Ein Workspace für Ihr Team. Gliedern Sie Visionen in OKRs und Ergebnisse. Laden Sie Mitarbeiter ein, wenn Sie bereit sind.",
      "workspace.corporate.firstTime.title": "Richten Sie Ihren ersten Workspace ein",
      "workspace.corporate.namePlaceholder": "z.B. Acme Marketing, Entwicklungsteam",
      "workspace.corporate.newOption": "Neuer Workspace",
      "workspace.corporate.newSubtitle": "Geben Sie ihm einen Namen, um mit der kaskadierenden Vision zu beginnen.",
      "workspace.corporate.newTitle": "Workspace erstellen",
      "workspace.family.createCta": "Erstellen",
      "workspace.family.descPlaceholder": "Was treibt diese Familie gemeinsam an?",
      "workspace.family.firstTime.cta": "Familien-Bereich erstellen",
      "workspace.family.firstTime.subtitle": "Ein gemeinsamer Workspace für Ihr Zuhause. Werte, Jahresthemen und Träume gemeinsam festhalten.",
      "workspace.family.firstTime.title": "Familien-Workspace einrichten",
      "workspace.family.namePlaceholder": "z.B. Familie Müller, Unser 2026",
      "workspace.family.newOption": "Neuer Familien-Workspace",
      "workspace.family.newSubtitle": "Nach der Familie oder dem Lebensabschnitt benennen. Sie können in mehreren sein.",
      "workspace.family.newTitle": "Familien-Workspace erstellen",
      "calendar.title": "Tagesplan",
      "calendar.loading": "Lade Tagesplan...",
      "calendar.continued": "Fortgesetzt:",
      "calendar.until": "(bis {{time}})",
      "calendar.addBlock": "+ Block zu dieser Zeit hinzufügen",
      "calendar.addBlockPrompt": "Block zu dieser Zeit hinzufügen",
      "calendar.editSchedule": "Zeitplan bearbeiten: {{title}}",
      "calendar.scheduleTitle": "Zeitplan: {{title}}",
      "calendar.startTime": "STARTZEIT",
      "calendar.duration": "DAUER",
      "calendar.itemType": "ELEMENTTYP",
      "calendar.description": "BESCHREIBUNG",
      "calendar.unschedule": "Vormerkung aufheben",
      "calendar.cancel": "Abbrechen",
      "calendar.update": "Aktualisieren",
      "calendar.schedule": "Planen",
      "calendar.hours": "Stunden",
      "calendar.mins": "Min",
      "calendar.custom": "Benutzerdefiniert...",
      "calendar.unscheduledItems": "Ungeplante Elemente",
      "calendar.beings": "Sein (Identitäten & Gewohnheiten)",
      "calendar.wants": "Wollen (Ziele & Wünsche)",
      "calendar.todos": "Tun (Heutige Aufgaben)",
      "calendar.noneUnscheduled": "Nichts ungeplant",
      "welcome.success": "Willkommen an Bord! Dein Arbeitsbereich ist bereit.",
      "welcome.error": "Fehler beim Initialisieren des Arbeitsbereichs. Bitte versuche es erneut.",
      "welcome.trial.title": "Willkommen bei Align Pro",
      "welcome.trial.subtitle": "Deine 14-tägige kostenlose Testversion ist aktiv. Wähle einen Fokusbereich aus, um deine erste Zielkaskade zu erstellen.",
      "welcome.focus.section_title": "Wähle deinen primären Fokusbereich:",
      "welcome.focus.health.title": "Gesundheit & Vitalität",
      "welcome.focus.health.desc": "Baue körperliche Energie, gesunde Gewohnheiten und tägliche Bewegung auf.",
      "welcome.focus.career.title": "Karriere & Fokus",
      "welcome.focus.career.desc": "Steigere die Produktivität, erreiche Projektziele und plane deine Arbeit.",
      "welcome.focus.mindfulness.title": "Achtsamkeit & Präsenz",
      "welcome.focus.mindfulness.desc": "Fördere die tägliche Reflexion, reduziere die Bildschirmzeit und bleibe präsent.",
      "welcome.focus.blank.title": "Frei erkunden (Leer)",
      "welcome.focus.blank.desc": "Beginne mit einem leeren Blatt. Erstelle deine eigene Kaskade von Grund auf neu.",
      "welcome.trial.highlight": "Pro-Testversion aktiviert",
      "welcome.trial.highlight_desc": "Du hast vollen Zugriff auf Live-KI-Coaching, Familien-/Unternehmensarbeitsbereiche und unbegrenzte Ziele. Keine Kreditkarte erforderlich.",
      "welcome.loading": "Arbeitsbereich wird initialisiert...",
      "welcome.trial.cta": "Meinen Arbeitsbereich betreten",
      "welcome.trial.guarantee": "Keine automatischen Gebühren.",
      "tour.step_stalled.title": "Blockierte Ziele anstoßen",
      "tour.step_stalled.desc_pro": "Wenn Ziele an Schwung verlieren, hilft diese Karte dabei, sie zu archivieren oder mit Ihrem KI-Coach zu reflektieren.",
      "tour.step_stalled.desc_starter": "Wenn Ziele an Schwung verlieren, hilft diese Karte dabei, sie zu archivieren oder eine kleine, sofortige Aktion hinzuzufügen.",
      "dialog.delete.being.title": "Dieses Sein löschen?",
      "dialog.delete.being.desc": "Alle verknüpften Ziele und Aufgaben werden zusammen mit dieser Identität entfernt.",
      "dialog.delete.want.title": "Dieses Ziel löschen?",
      "dialog.delete.want.desc": "Alle verknüpften Aufgaben werden zusammen mit diesem Ziel gelöscht.",
      "dialog.delete.todo.title": "Diese Aufgabe löschen?",
      "dialog.delete.todo.desc": "Diese Aufgabe wird dauerhaft gelöscht.",
      "dialog.delete.confirm": "Löschen",
      "dialog.delete.cancel": "Abbrechen"
    }
  },
  zh: {
    translation: {
      "about.back": "返回",
      "about.framework.be.desc": "专注于您的核心价值观、身份陈述和习惯。",
      "about.framework.be.title": "成为 (身份)",
      "about.framework.do.desc": "协调您的日常任务和即时清单。",
      "about.framework.do.title": "去做 (行动)",
      "about.framework.title": "核心框架",
      "about.framework.want.desc": "规划支持您身份的具体目标和抱负。",
      "about.framework.want.title": "想要 (目标)",
      "about.modes.corporate.desc": "用于专业的团队对齐、企业愿景和级联 OKR。",
      "about.modes.corporate.title": "企业空间",
      "about.modes.family.desc": "用于共享家庭价值观、邀请和家庭愿景板。",
      "about.modes.family.title": "家庭空间",
      "about.modes.personal.desc": "用于个人习惯追踪、连续天数和每日反思。",
      "about.modes.personal.title": "个人空间",
      "about.modes.title": "一个框架，三个空间",
      "about.philosophy.body": "Align 旨在帮助您通过将日常任务与长期生活愿景以及您正在成为的人联系起来，从而有目的地生活。",
      "about.philosophy.title": "我们的哲学",
      "about.tagline": "从行动到身份",
      "about.title": "关于 Align",
      "about.values.calm.desc": "极简的用户界面，旨在减少数字干扰。",
      "about.values.calm.title": "冷静专注",
      "about.values.intentionality.desc": "消除繁琐的工作，专注于核心事务。",
      "about.values.intentionality.title": "意图性",
      "about.values.reflection.desc": "通过内置的检查机制，暂停并审视进度。",
      "about.values.reflection.title": "反思",
      "about.values.title": "我们的设计原则",
      "aiChat.commit.error": "保存项目失败。",
      "aiChat.commit.success": "已向系统中添加了 {{items}} 个项目。",
      "aiChat.continue.hint": "回复以继续此对话。⌘ + Enter 发送。",
      "aiChat.continue.placeholder": "回答上述问题，或添加更多内容...",
      "aiChat.empty": "没有找到可以添加的内容。请尝试具体描述目标、任务或你想成为的角色。",
      "aiChat.extract.error": "AI 无法处理该内容。请重试？",
      "aiChat.fab.label": "Align 助手",
      "aiChat.hint": "⌘ + Enter 发送。点击麦克风说话。",
      "aiChat.listening": "正在倾听……请自然说话，我会整理好内容。",
      "aiChat.panel.close": "关闭",
      "aiChat.placeholder.examples.0": "告诉我你想做什么——目标、任务、想成为的角色……",
      "aiChat.placeholder.examples.1": "尝试：",
      "aiChat.placeholder.examples.2": "尝试：",
      "aiChat.placeholder.examples.3": "尝试：",
      "aiChat.reflections": "感悟",
      "aiChat.review.commit": "添加到我的系统",
      "aiChat.review.followup": "跟进",
      "aiChat.review.nothingSelected": "请选择至少一个项目以添加。",
      "aiChat.review.title": "查看分析结果",
      "aiChat.thread.reset": "重新开始",
      "aiChat.voice.error": "语音输入失败。",
      "aiChat.voice.tooltip": "用语音代替输入",
      "aiChat.voice.unsupported": "此浏览器不支持语音输入。",
      "analytics.being.label": "成为",
      "analytics.being.subtitle": "身份与价值观",
      "analytics.motivation.high": "你取得了令人难以置信的进步。继续让你的行动与你的愿景保持一致。",
      "analytics.motivation.low": "旅程始于第一步。今天就开始吧。",
      "analytics.motivation.medium": "每一个小行动都让你更接近你想成为的人。",
      "analytics.reflections": "反思",
      "analytics.reflections.entries": "日记条目",
      "analytics.streaks.active": "活跃连续",
      "analytics.streaks.longest": "最长：{{count}}天",
      "analytics.subtitle": "追踪从行动到身份的旅程",
      "analytics.tasks.completed": "已完成任务",
      "analytics.tasks.rate": "{{rate}}%完成率",
      "analytics.title": "你的进度",
      "analytics.todo.label": "去做",
      "analytics.todo.subtitle": "行动与任务",
      "analytics.want.label": "想要",
      "analytics.want.subtitle": "目标与愿望",
      "analytics.wants.completed": "{{count}}已完成",
      "analytics.wants.progress": "想要进度",
      "auth.email": "邮箱",
      "auth.google": "使用 Google 继续",
      "auth.loading": "请稍候...",
      "auth.loading.google": "正在连接...",
      "auth.loading.login": "正在登录...",
      "auth.loading.signup": "正在创建账户...",
      "auth.login": "欢迎回来",
      "auth.name": "姓名",
      "auth.or": "或",
      "auth.password": "密码",
      "auth.signup": "创建账户",
      "auth.submit.login": "登录",
      "auth.submit.signup": "创建账户",
      "auth.toggle.login": "没有账户？注册",
      "auth.toggle.signup": "已有账户？登录",
      "auth.verify.backToHome": "返回首页",
      "auth.verify.error": "验证失败。该链接可能已过期或无效。",
      "auth.verify.errorTitle": "验证失败",
      "auth.verify.goToLogin": "前往登录",
      "auth.verify.needed": "登录前请先验证您的邮箱地址。",
      "auth.verify.noToken": "未提供验证 Token。",
      "auth.verify.resend": "重新发送邮件",
      "auth.verify.resentBody": "如果该邮箱已注册，一封新的验证邮件已发送。",
      "auth.verify.successBody": "您的邮箱已成功验证。现在可以登录您的账户了。",
      "auth.verify.successTitle": "账户验证成功！",
      "auth.verify.verifyingBody": "请稍候，我们正在确认您的邮箱地址...",
      "auth.verify.verifyingTitle": "正在验证邮箱",
      "being.days": "天",
      "being.description.placeholder": "描述你自己的这个方面...",
      "being.empty": "你正在成为谁？",
      "being.practice": "今日练习",
      "being.streak": "连续",
      "being.title.placeholder": "你正在成为谁？",
      "being.type.habit": "习惯",
      "being.type.identity": "身份",
      "being.type.value": "价值观",
      "corporate.firstTime.cta": "创建空间",
      "corporate.firstTime.subtitle": "协同空间可以帮助团队或家庭围绕共同愿景、目标和关键结果进行对齐。你可以加入多个空间。",
      "corporate.firstTime.title": "设置你的第一个空间",
      "corporate.goal.createError": "添加失败。",
      "corporate.goal.created": "已添加。",
      "corporate.goal.deleteConfirm": "删除此目标？关联的所有子项目也将被移除。",
      "corporate.goal.deleteError": "删除失败。",
      "corporate.goal.deleted": "已删除。",
      "corporate.goal.progress": "进度",
      "corporate.goal.updateError": "无法更新进度。",
      "corporate.goals.fetchError": "无法加载目标。",
      "corporate.kr.add": "添加关键结果",
      "corporate.kr.descPlaceholder": "可选背景信息。",
      "corporate.kr.titlePlaceholder": "哪些可衡量的结果能证明 OKR 的实现？",
      "corporate.level.kr": "关键结果",
      "corporate.level.okr": "OKR",
      "corporate.level.vision": "愿景",
      "corporate.loading": "正在加载您的工作空间...",
      "corporate.okr.add": "添加 OKR",
      "corporate.okr.descPlaceholder": "可选背景信息。",
      "corporate.okr.titlePlaceholder": "什么目标服务于这个愿景？",
      "corporate.type.corporate": "企业",
      "corporate.type.corporateDesc": "团队或组织。愿景级联 → OKRs → 关键结果。",
      "corporate.type.family": "家庭",
      "corporate.type.familyDesc": "家庭成员。共同价值观与年度主题。",
      "corporate.vision.add": "添加愿景",
      "corporate.vision.descPlaceholder": "可选背景信息，即原因。",
      "corporate.vision.empty": "尚未设定愿景。从一段阐明此空间奋斗目标的话语开始吧。",
      "corporate.vision.titlePlaceholder": "此工作空间的目标是什么？",
      "corporate.workspace.create": "创建",
      "corporate.workspace.createError": "无法创建协同空间。",
      "corporate.workspace.created": "协同空间已创建。",
      "corporate.workspace.descLabel": "描述（可选）",
      "corporate.workspace.descPlaceholder": "此空间存在是为了做什么？",
      "corporate.workspace.nameLabel": "空间名称",
      "corporate.workspace.namePlaceholder": "例如 Acme Marketing，史密斯家庭",
      "corporate.workspace.new": "新协同空间",
      "corporate.workspace.newSubtitle": "输入名称以开始规划目标。",
      "corporate.workspace.newTitle": "创建一个工作空间",
      "corporate.workspace.typeLabel": "类型",
      "corporate.workspaces.fetchError": "无法加载您的工作空间。",
      "family.cat.annual_themes.contentPlaceholder": "这个主题具体指什么？年终时如何检验它是否实现？",
      "family.cat.annual_themes.empty": "今年的年度主题是什么？选择一到两个，不要贪多。",
      "family.cat.annual_themes.tagline": "塑造今年的主题。一句话或一个词。",
      "family.cat.annual_themes.title": "今年",
      "family.cat.annual_themes.titlePlaceholder": "例如：户外之年、倾听之年",
      "family.cat.dreams.contentPlaceholder": "为什么要实现这个梦想？那会是怎样的感觉？",
      "family.cat.dreams.empty": "写下家里人一直不敢大声说出来的愿望。",
      "family.cat.dreams.tagline": "更长远的目标。没有期限，无需害羞。",
      "family.cat.dreams.title": "梦想",
      "family.cat.dreams.titlePlaceholder": "例如：新西兰旅行、建造树屋",
      "family.cat.values.contentPlaceholder": "对我们而言，这个价值观在实践中具体如何体现？",
      "family.cat.values.empty": "尚未记录家庭价值观。从最重要的一个开始吧。",
      "family.cat.values.tagline": "家庭所代表的事物。不妥协的原则。",
      "family.cat.values.title": "价值观",
      "family.cat.values.titlePlaceholder": "例如：诚实、冒险、全心投入",
      "family.createError": "无法添加该项。",
      "family.created": "已添加。",
      "family.deleteConfirm": "确定要从愿景板中移除该项吗？",
      "family.deleteError": "无法移除。",
      "family.deleted": "已移除。",
      "family.fetchError": "无法加载愿景板。",
      "family.loading": "正在加载愿景板……",
      "family.subtitle": "家庭愿景板",
      "form.cancel": "取消",
      "form.create": "创建",
      "invite.acceptCta": "接受邀请",
      "invite.acceptError": "无法接受邀请。",
      "invite.acceptSuccess": "已成功加入 {{workspace}}。",
      "invite.alreadyUsedBody": "此邀请已被接受过。",
      "invite.alreadyUsedTitle": "邀请已被使用",
      "invite.backToDashboard": "返回仪表盘",
      "invite.backToHome": "返回首页",
      "invite.errorTitle": "邀请无效",
      "invite.expiredBody": "请让邀请人重新发送一份新的链接。",
      "invite.expiredTitle": "邀请已过期",
      "invite.heading": "加入 {{workspace}}",
      "invite.label": "邀请",
      "invite.loadError": "无法加载该邀请。",
      "invite.redirecting": "正在带您前往工作空间...",
      "invite.signInToAccept": "登录以接受邀请",
      "invite.subheading": "您已被邀请作为 {{role}} 加入 {{workspace}}。",
      "invite.welcomeTitle": "欢迎来到 {{workspace}}",
      "landing.cta": "开始您的旅程",
      "landing.description": "不仅仅是任务。连接你所<1>做的</1>、所<3>想要的</3>，以及你正在<5>成为的人</5>。",
      "landing.tagline": "从行动到身份",
      "landing.title": "对齐",
      "layer.being": "成为",
      "layer.being.subtitle": "身份与价值观",
      "layer.todo": "去做",
      "layer.todo.subtitle": "今日行动",
      "layer.want": "想要",
      "layer.want.subtitle": "目标与愿望",
      "members.invite.copyFail": "复制链接失败。",
      "members.invite.copyLink": "复制邀请链接",
      "members.invite.emailPlaceholder": "name@example.com",
      "members.invite.error": "发送邀请失败。",
      "members.invite.linkCopied": "邀请链接已复制到剪贴板。",
      "members.invite.linkHint": "如果配置了邮箱则会发送邮件。邀请链接已自动复制，可以直接分享。",
      "members.invite.revoke": "撤销",
      "members.invite.revokeConfirm": "确定要撤销此邀请吗？链接将失效。",
      "members.invite.revokeError": "无法撤销邀请。",
      "members.invite.revoked": "邀请已撤销。",
      "members.invite.send": "发送",
      "members.invite.sent": "邀请已发送。",
      "members.invite.title": "邀请团队成员",
      "members.list.title": "成员 ({{count}})",
      "members.list.you": "您",
      "members.loadError": "无法加载成员。",
      "members.loading": "正在加载成员……",
      "members.pending.title": "待处理邀请 ({{count}})",
      "members.role.admin": "管理员",
      "members.role.manager": "经理",
      "members.role.member": "成员",
      "members.title": "成员",
      "mode.corporate": "企业",
      "mode.family": "家庭",
      "mode.personal": "个人",
      "nav.about": "关于",
      "nav.back": "返回仪表板",
      "nav.calendar": "日历",
      "nav.dashboard": "仪表板",
      "nav.help": "帮助",
      "nav.logout": "退出",
      "nav.progress": "进度",
      "nav.reflect": "反思",
      "reflection.empty": "还没有反思。在上面开始您的旅程！",
      "reflection.past": "过去的反思",
      "reflection.placeholder": "在这里写下你的想法...",
      "reflection.save": "保存反思",
      "reflection.saving": "保存中...",
      "reflection.subtitle": "花一点时间暂停并反思您的旅程",
      "reflection.title": "每日反思",
      "review.dismiss": "暂时隐藏",
      "review.engage": "对此进行反思",
      "review.label": "每周签到",
      "review.skipWeek": "跳过本周",
      "review.statsCompleted": "本周完成了对齐目标中 {{total}} 项里的 {{done}} 项",
      "toast.auth.error": "认证失败",
      "toast.being.created": "成为已创建",
      "toast.being.deleted": "成为已删除",
      "toast.being.error": "创建成为失败",
      "toast.reflection.error": "保存反思失败",
      "toast.reflection.saved": "反思已保存",
      "toast.session.expired": "会话已过期。请重新登录。",
      "toast.streak": "连续：{{count}}天！",
      "toast.todo.created": "任务已创建",
      "toast.todo.deleted": "任务已删除",
      "toast.todo.error": "创建任务失败",
      "toast.want.created": "想要已创建",
      "toast.want.deleted": "想要已删除",
      "toast.want.error": "创建想要失败",
      "toast.welcome.login": "欢迎回来！",
      "toast.welcome.signup": "欢迎来到对齐！",
      "today.embody": "体现",
      "today.empty": "今天没有安排。添加任务或在下方询问助理。",
      "today.label": "今天",
      "today.next": "下一步",
      "todo.connect.being": "连接到成为（可选）",
      "todo.connect.want": "连接到想要（可选）",
      "todo.description.placeholder": "详情（可选）",
      "todo.empty": "还没有任务。创建一个开始吧！",
      "todo.title.placeholder": "需要做什么？",
      "tour.btn.done": "完成",
      "tour.btn.next": "下一步",
      "tour.btn.prev": "上一步",
      "tour.helpTooltip": "帮助指南",
      "tour.step1.desc": "Align 帮助您架起“想成为谁”与“每天做什么”之间的桥梁。让我们花一分钟快速浏览一下它的工作原理。",
      "tour.step1.title": "欢迎使用 Align",
      "tour.step2.desc": "这是您层级系统的根基。定义您想成为的人或想践行的价值观（例如，“高级软件开发人员”或“健康的跑者”）。",
      "tour.step2.title": "1. To Be (身份与价值观)",
      "tour.step3.desc": "设定支持您身份的具体目标。例如，“精通分布式系统设计”支持您的开发人员身份。",
      "tour.step3.title": "2. To Want (目标与渴望)",
      "tour.step4.desc": "在此处创建即时任务并将其链接到您的目标。当您勾选完成这些任务时，您目标的进度条会自动实时更新！",
      "tour.step4.title": "3. To Do (今日行动)",
      "tour.step5.desc": "您的侧边栏显示您今天的焦点身份、每周签到情况以及接下来需要关注的前三个高优先级任务。",
      "tour.step5.title": "您的每日驾驶舱",
      "tour.step6.desc": "在这里与您的 AI 教练交流。写下对一天的反思，AI 将自动为您提取并关联新的身份、目标和任务！",
      "tour.step6.title": "AI 反思与教练",
      "tour.step7.desc": "点击“Calendar”（日历）查看和自定义您的每日日程，点击“Reflect”（反思）撰写每日日志并查看反思历史，或点击“Progress”（进度）查看您的可视化分析仪表盘和连续达标天数。",
      "tour.step7.title": "日程、反思与追踪进度",
      "tour.calendar.step1.desc": "欢迎使用您的日历。在这里，您可以在可视化时间线中组织您的每日活动。",
      "tour.calendar.step1.title": "每日计划工作台",
      "tour.calendar.step2.desc": "在日期之间移动以提前安排任务，或回顾您过去几天的日程。",
      "tour.calendar.step2.title": "日期导航",
      "tour.calendar.step3.desc": "此面板包含您所有活跃的角色、目标和任务，这些项目尚未被放入今天的日程安排中。",
      "tour.calendar.step3.title": "未安排项目",
      "tour.calendar.step4.desc": "点击“+ 在此时间段添加区块”以从未安排列表中选择一项任务并为其分配时间。",
      "tour.calendar.step4.title": "每小时时间线",
      "tour.calendar.step5.desc": "点击此按钮可在日历和三栏式仪表盘之间来回切换。",
      "tour.calendar.step5.title": "切换视图模式",
      "want.description.placeholder": "为什么这对你很重要？",
      "want.empty": "还没有目标。你想要什么？",
      "want.progress": "进度",
      "want.title.placeholder": "你想要什么？",
      "workspace.corporate.createCta": "创建",
      "workspace.corporate.descPlaceholder": "此协同空间存在的目的？",
      "workspace.corporate.firstTime.cta": "创建工作空间",
      "workspace.corporate.firstTime.subtitle": "一个属于你团队的空间。规划 vision 到 OKRs 和关键结果。随时可以邀请协作者加入。",
      "workspace.corporate.firstTime.title": "设置你的第一个工作空间",
      "workspace.corporate.namePlaceholder": "例如：Acme Marketing，技术小组",
      "workspace.corporate.newOption": "新工作空间",
      "workspace.corporate.newSubtitle": "给它起个名字就可以开始为之行动了。",
      "workspace.corporate.newTitle": "创建一个工作空间",
      "workspace.family.createCta": "创建",
      "workspace.family.descPlaceholder": "什么推动了整个家庭共同向前？",
      "workspace.family.firstTime.cta": "创建家庭工作区",
      "workspace.family.firstTime.subtitle": "家庭共享的空间。一起制定价值观、年度主题以及携手追逐的梦想。",
      "workspace.family.firstTime.title": "设置家庭共享工作空间",
      "workspace.family.namePlaceholder": "例如：史密斯家，我们的 2026",
      "workspace.family.newOption": "新家庭工作区",
      "workspace.family.newSubtitle": "以家或某个共享的主题命名。你可以处于多个空间。",
      "workspace.family.newTitle": "创建一个家庭共享工作空间",
      "calendar.title": "今日日程",
      "calendar.loading": "日程加载中...",
      "calendar.continued": "继续：",
      "calendar.until": "(直到 {{time}})",
      "calendar.addBlock": "+ 添加时间块",
      "calendar.addBlockPrompt": "添加时间块",
      "calendar.editSchedule": "编辑日程：{{title}}",
      "calendar.scheduleTitle": "日程：{{title}}",
      "calendar.startTime": "开始时间",
      "calendar.duration": "持续时间",
      "calendar.itemType": "类型",
      "calendar.description": "描述",
      "calendar.unschedule": "取消日程",
      "calendar.cancel": "取消",
      "calendar.update": "更新",
      "calendar.schedule": "排程",
      "calendar.hours": "小时",
      "calendar.mins": "分钟",
      "calendar.custom": "自定义...",
      "calendar.unscheduledItems": "待安排项",
      "calendar.beings": "成为 (身份与习惯)",
      "calendar.wants": "想要 (目标与渴望)",
      "calendar.todos": "去做 (今日行动)",
      "calendar.noneUnscheduled": "无待安排项",
      "welcome.success": "欢迎加入！您的工作空间已准备就绪。",
      "welcome.error": "未能初始化工作空间，请重试。",
      "welcome.trial.title": "欢迎使用 Align Pro",
      "welcome.trial.subtitle": "您的 14 天免费试用已激活。请选择一个重点领域来开始您的第一个目标级联。",
      "welcome.focus.section_title": "选择您的首要关注领域：",
      "welcome.focus.health.title": "健康与活力",
      "welcome.focus.health.desc": "建立身体能量、健康习惯和日常锻炼。",
      "welcome.focus.career.title": "职业与专注",
      "welcome.focus.career.desc": "提高生产力、实现项目目标并规划工作。",
      "welcome.focus.mindfulness.title": "正念与当下",
      "welcome.focus.mindfulness.desc": "培养日常反思，减少屏幕时间并保持专注。",
      "welcome.focus.blank.title": "自由探索（空白）",
      "welcome.focus.blank.desc": "从一张白纸开始。从头开始创建您自己的自定义级联。",
      "welcome.trial.highlight": "专业版试用已激活",
      "welcome.trial.highlight_desc": "您可以完全访问实时 AI 教练、家庭/企业工作空间以及无限目标。无需信用卡。",
      "welcome.loading": "正在初始化工作空间...",
      "welcome.trial.cta": "进入我的工作空间",
      "welcome.trial.guarantee": "无自动扣费。",
      "tour.step_stalled.title": "停滞目标提醒",
      "tour.step_stalled.desc_pro": "当目标失去动力时，此卡片可帮助您将其归档或与您的 AI 教练一起反思以摆脱困境。",
      "tour.step_stalled.desc_starter": "当目标失去动力时，此卡片可帮助您将其归档或添加一个微小的即时行动以摆脱困境。",
      "dialog.delete.being.title": "删除此存在？",
      "dialog.delete.being.desc": "所有关联的目标和任务都将与该身份一起被移除。",
      "dialog.delete.want.title": "删除此目标？",
      "dialog.delete.want.desc": "所有关联的任务都将与该目标一起被删除。",
      "dialog.delete.todo.title": "删除此任务？",
      "dialog.delete.todo.desc": "此任务将被永久删除。",
      "dialog.delete.confirm": "删除",
      "dialog.delete.cancel": "取消"
    }
  },
  hi: {
    translation: {
      "about.back": "पीछे",
      "about.framework.be.desc": "आपके मूल मूल्यों, पहचान बयानों और आदतों पर ध्यान केंद्रित करता है।",
      "about.framework.be.title": "बनना है (पहचान)",
      "about.framework.do.desc": "आपके दैनिक कार्यों और तत्काल सूचियों का समन्वय करता है।",
      "about.framework.do.title": "करना है (कार्य)",
      "about.framework.title": "मूल ढांचा",
      "about.framework.want.desc": "आपके वास्तविक लक्ष्यों और आकांक्षाओं को दर्शाता है जो आपकी पहचान का समर्थन करते हैं।",
      "about.framework.want.title": "इच्छा (लक्ष्य)",
      "about.modes.corporate.desc": "पेशेवर टीम संरेखण, कंपनी के दृष्टिकोण और OKRs के लिए।",
      "about.modes.corporate.title": "कॉर्पोरेट स्थान",
      "about.modes.family.desc": "साझा पारिवारिक मूल्यों, आमंत्रणों और पारिवारिक दृष्टिकोण बोर्डों के लिए।",
      "about.modes.family.title": "पारिवारिक स्थान",
      "about.modes.personal.desc": "निजी आदतों, सिलसिले और दैनिक आत्मचिंतन के लिए।",
      "about.modes.personal.title": "व्यक्तिगत स्थान",
      "about.modes.title": "एक ढांचा, तीन वर्कस्पेस",
      "about.philosophy.body": "Align आपको अपने दैनिक कार्यों को अपने दीर्घकालिक जीवन दृष्टिकोण और आप कौन बन रहे हैं, उससे जोड़कर उद्देश्यपूर्ण ढंग से जीने में मदद करने के लिए डिज़ाइन किया गया है।",
      "about.philosophy.title": "हमारा दर्शन",
      "about.tagline": "कर्म से पहचान तक",
      "about.title": "Align के बारे में",
      "about.values.calm.desc": "डिजिटल शोर को कम करने के लिए डिज़ाइन किया गया एक न्यूनतम यूजर इंटरफेस।",
      "about.values.calm.title": "शांत फोकस",
      "about.values.intentionality.desc": "महत्वपूर्ण चीज़ों पर ध्यान केंद्रित करने के लिए व्यस्तता को समाप्त करना।",
      "about.values.intentionality.title": "उद्देश्यपूर्णता",
      "about.values.reflection.desc": "बिल्ट-इन चेक के माध्यम से प्रगति की समीक्षा करने के लिए रुकना।",
      "about.values.reflection.title": "आत्मचिंतन",
      "about.values.title": "हमारे डिज़ाइन सिद्धांत",
      "aiChat.commit.error": "आइटम सहेजने में विफल।",
      "aiChat.commit.success": "आपके सिस्टम में {{items}} आइटम जोड़े गए।",
      "aiChat.continue.hint": "चर्चा जारी रखने के लिए उत्तर दें। भेजने के लिए ⌘ + Enter।",
      "aiChat.continue.placeholder": "ऊपर दिए गए प्रश्न का उत्तर दें, या कुछ और जोड़ें...",
      "aiChat.empty": "मुझे जोड़ने के लिए कुछ नहीं मिला। कृपया लक्ष्यों या कार्यों के बारे में अधिक स्पष्ट रहें।",
      "aiChat.extract.error": "एआई इसे संसाधित नहीं कर सका। फिर से प्रयास करें?",
      "aiChat.fab.label": "एलाइन एजेंट",
      "aiChat.hint": "भेजने के लिए ⌘ + Enter दबाएं। बोलने के लिए माइक पर टैप करें।",
      "aiChat.listening": "सुन रहा हूँ… स्वाभाविक रूप से बोलें, मैं इसे व्यवस्थित कर दूँगा।",
      "aiChat.panel.close": "बंद करें",
      "aiChat.placeholder.examples.0": "बताएं कि आपके दिमाग में क्या है — लक्ष्य, कार्य, आप कौन बनना चाहते हैं...",
      "aiChat.placeholder.examples.1": "कोशिश करें: \"मैं एक धैर्यवान माता-पिता बनना चाहता हूँ और अपने बच्चों के साथ महीने में एक किताब पढ़ना चाहता हूँ।\"",
      "aiChat.placeholder.examples.2": "कोशिश करें: \"अक्टूबर में हाफ मैराथन दौड़ें। इस वीकेंड जूते खरीदें।\"",
      "aiChat.placeholder.examples.3": "कोशिश करें: \"थका हुआ महसूस कर रहा हूँ। मुझे शाम 6 बजे काम रोकने की सख्त ज़रूरत है।\"",
      "aiChat.reflections": "आत्मचिंतन",
      "aiChat.review.commit": "मेरे सिस्टम में जोड़ें",
      "aiChat.review.followup": "फ़ॉलो-अप",
      "aiChat.review.nothingSelected": "जोड़ने के लिए कम से कम एक आइटम चुनें।",
      "aiChat.review.title": "समीक्षा करें कि मुझे क्या मिला",
      "aiChat.thread.reset": "फिर से शुरू करें",
      "aiChat.voice.error": "वॉयस इनपुट विफल रहा।",
      "aiChat.voice.tooltip": "टाइप करने के बजाय बोलें",
      "aiChat.voice.unsupported": "इस ब्राउज़र में वॉयस इनपुट समर्थित नहीं है।",
      "analytics.being.label": "बनना है",
      "analytics.being.subtitle": "पहचान और मूल्य",
      "analytics.motivation.high": "आप अविश्वसनीय प्रगति कर रहे हैं। अपने कार्यों को अपने दृष्टिकोण के साथ संरेखित करते रहें।",
      "analytics.motivation.low": "यात्रा एक कदम से शुरू होती. आज ही शुरू करें।",
      "analytics.motivation.medium": "हर छोटा कार्य आपको उसके करीब लाता है जो आप बनना चाहते हैं।",
      "analytics.reflections": "आत्मचिंतन",
      "analytics.reflections.entries": "जर्नल प्रविष्टियाँ",
      "analytics.streaks.active": "सक्रिय सिलसिले",
      "analytics.streaks.longest": "सबसे लंबा: {{count}} दिन",
      "analytics.subtitle": "कर्म से पहचान तक की अपनी यात्रा को ट्रैक करें",
      "analytics.tasks.completed": "पूर्ण किए गए कार्य",
      "analytics.tasks.rate": "{{rate}}% पूर्णता दर",
      "analytics.title": "आपकी प्रगति",
      "analytics.todo.label": "करना है",
      "analytics.todo.subtitle": "कार्य और गतिविधियां",
      "analytics.want.label": "इच्छा",
      "analytics.want.subtitle": "लक्ष्य और इच्छाएं",
      "analytics.wants.completed": "{{count}} पूर्ण",
      "analytics.wants.progress": "इच्छाओं की प्रगति",
      "auth.email": "ईमेल",
      "auth.google": "गूगल के साथ जारी रखें",
      "auth.loading": "कृपया प्रतीक्षा करें...",
      "auth.loading.google": "कनेक्ट किया जा रहा है...",
      "auth.loading.login": "साइन इन किया जा रहा है...",
      "auth.loading.signup": "खाता बनाया जा रहा है...",
      "auth.login": "स्वागत है",
      "auth.name": "नाम",
      "auth.or": "या",
      "auth.password": "पासवर्ड",
      "auth.signup": "खाता बनाएं",
      "auth.submit.login": "साइन इन करें",
      "auth.submit.signup": "खाता बनाएं",
      "auth.toggle.login": "खाता नहीं है? साइन अप करें",
      "auth.toggle.signup": "पहले से ही खाता है? साइन इन करें",
      "auth.verify.backToHome": "होम पर वापस जाएं",
      "auth.verify.error": "सत्यापन विफल रहा। लिंक समाप्त हो गया हो सकता है या अमान्य है।",
      "auth.verify.errorTitle": "सत्यापन विफल रहा",
      "auth.verify.goToLogin": "लॉगिन पर जाएं",
      "auth.verify.needed": "कृपया लॉगिन करने से पहले अपना ईमेल पता सत्यापित करें।",
      "auth.verify.noToken": "कोई सत्यापन टोकन प्रदान नहीं किया गया।",
      "auth.verify.resend": "ईमेल पुन: भेजें",
      "auth.verify.resentBody": "यदि उस ईमेल के लिए कोई खाता मौजूद है, तो एक नया सत्यापन लिंक भेज दिया गया है।",
      "auth.verify.successBody": "आपका ईमेल सफलतापूर्वक सत्यापित हो गया है। अब आप अपने खाते में लॉग इन कर सकते हैं।",
      "auth.verify.successTitle": "खाता सत्यापित हो गया!",
      "auth.verify.verifyingBody": "कृपया प्रतीक्षा करें जब तक हम आपके ईमेल पते की पुष्टि करते हैं...",
      "auth.verify.verifyingTitle": "ईमेल सत्यापित किया जा रहा है",
      "being.days": "दिन",
      "being.description.placeholder": "अपने इस पहलू का वर्णन करें...",
      "being.empty": "आप क्या बन रहे हैं?",
      "being.practice": "आज अभ्यास करें",
      "being.streak": "सिलसिला",
      "being.title.placeholder": "आप क्या बन रहे हैं?",
      "being.type.habit": "आदत",
      "being.type.identity": "पहचान",
      "being.type.value": "मूल्य",
      "corporate.firstTime.cta": "वर्कस्पेस बनाएं",
      "corporate.firstTime.subtitle": "एक वर्कस्पेस वह स्थान है जहाँ आप साझा दृष्टिकोण, लक्ष्यों और प्रमुख परिणामों के साथ एक टीम या परिवार को संरेखित करते हैं।",
      "corporate.firstTime.title": "अपना पहला वर्कस्पेस सेट करें",
      "corporate.goal.createError": "उसे जोड़ा नहीं जा सका।",
      "corporate.goal.created": "जोड़ दिया गया।",
      "corporate.goal.deleteConfirm": "क्या इस लक्ष्य को हटाना चाहते हैं? इससे जुड़े सभी उप-आइटम भी हटा दिए जाएंगे।",
      "corporate.goal.deleteError": "हटाया नहीं जा सका।",
      "corporate.goal.deleted": "हटा दिया गया।",
      "corporate.goal.progress": "प्रगति",
      "corporate.goal.updateError": "प्रगति अपडेट नहीं की जा सकी।",
      "corporate.goals.fetchError": "लक्ष्य लोड नहीं हो सके।",
      "corporate.kr.add": "प्रमुख परिणाम जोड़ें",
      "corporate.kr.descPlaceholder": "वैकल्पिक संदर्भ।",
      "corporate.kr.titlePlaceholder": "कौन सा मापने योग्य परिणाम OKR को साबित करता है?",
      "corporate.level.kr": "प्रमुख परिणाम",
      "corporate.level.okr": "OKR",
      "corporate.level.vision": "दृष्टिकोण",
      "corporate.loading": "आपके वर्कस्पेस लोड किए जा रहे हैं...",
      "corporate.okr.add": "OKR जोड़ें",
      "corporate.okr.descPlaceholder": "वैकल्पिक संदर्भ।",
      "corporate.okr.titlePlaceholder": "कौन सा उद्देश्य इस दृष्टिकोण की सेवा करता है?",
      "corporate.type.corporate": "कॉर्पोरेट",
      "corporate.type.corporateDesc": "टीम या संगठन। दृष्टिकोण → OKRs → प्रमुख परिणाम।",
      "corporate.type.family": "पारिवारिक",
      "corporate.type.familyDesc": "परिवार। साझा मूल्य और वार्षिक विषय।",
      "corporate.vision.add": "दृष्टिकोण जोड़ें",
      "corporate.vision.descPlaceholder": "वैकल्पिक संदर्भ, क्यों।",
      "corporate.vision.empty": "अभी तक कोई दृष्टिकोण निर्धारित नहीं है। इस वर्कस्पेस के उद्देश्य के बारे में एक सरल कथन से शुरू करें।",
      "corporate.vision.titlePlaceholder": "यह वर्कस्पेस क्या हासिल करना चाहता है?",
      "corporate.workspace.create": "बनाएं",
      "corporate.workspace.createError": "वर्कस्पेस नहीं बनाया जा सका।",
      "corporate.workspace.created": "वर्कस्पेस बनाया गया।",
      "corporate.workspace.descLabel": "विवरण (वैकल्पिक)",
      "corporate.workspace.descPlaceholder": "यह वर्कस्पेस किस उद्देश्य के लिए है?",
      "corporate.workspace.nameLabel": "नाम",
      "corporate.workspace.namePlaceholder": "जैसे: एक्मे मार्केटिंग, शर्मा परिवार",
      "corporate.workspace.new": "नया वर्कस्पेस",
      "corporate.workspace.newSubtitle": "इसे एक नाम दें और आप दृष्टिकोण को कर्म में बदलना शुरू कर सकते हैं।",
      "corporate.workspace.newTitle": "एक वर्कस्पेस बनाएं",
      "corporate.workspace.typeLabel": "प्रकार",
      "corporate.workspaces.fetchError": "आपके वर्कस्पेस लोड नहीं हो सके।",
      "family.cat.annual_themes.contentPlaceholder": "यह विषय कैसा दिखता है? वर्ष के अंत में इसे क्या साबित करेगा?",
      "family.cat.annual_themes.empty": "इस वर्ष का विषय क्या है? एक या दो चुनें — दस नहीं।",
      "family.cat.annual_themes.tagline": "इस वर्ष को आकार देने वाले विषय। एक शब्द या एक वाक्य।",
      "family.cat.annual_themes.title": "यह वर्ष",
      "family.cat.annual_themes.titlePlaceholder": "जैसे: बाहरी गतिविधियों का वर्ष, सुनने का वर्ष",
      "family.cat.dreams.contentPlaceholder": "यह सपना क्यों? यह कैसा महसूस कराएगा?",
      "family.cat.dreams.empty": "कुछ ऐसा लिखें जो परिवार में किसी ने जोर से बोलने की हिम्मत न की हो।",
      "family.cat.dreams.tagline": "लंबे समय के सपने। कोई समय सीमा नहीं, कोई शर्म नहीं।",
      "family.cat.dreams.title": "सपने",
      "family.cat.dreams.titlePlaceholder": "जैसे: न्यूजीलैंड की यात्रा, पेड़ पर घर बनाना",
      "family.cat.values.contentPlaceholder": "यह मूल्य हमारे लिए व्यवहार में कैसा दिखता है?",
      "family.cat.values.empty": "अभी तक कोई मूल्य नहीं लिखा गया है। सबसे महत्वपूर्ण से शुरू करें।",
      "family.cat.values.tagline": "यह परिवार किसके साथ खड़ा है। बुनियादी बातें।",
      "family.cat.values.title": "मूल्य",
      "family.cat.values.titlePlaceholder": "जैसे: ईमानदारी, रोमांच, साथ देना",
      "family.createError": "जोड़ा नहीं जा सका।",
      "family.created": "जोड़ दिया गया।",
      "family.deleteConfirm": "विजन बोर्ड से इस आइटम को हटाएं?",
      "family.deleteError": "हटाया नहीं जा सका।",
      "family.deleted": "हटा दिया गया।",
      "family.fetchError": "विजन बोर्ड लोड नहीं किया जा सका।",
      "family.loading": "बोर्ड लोड किया जा रहा है...",
      "family.subtitle": "पारिवारिक विजन बोर्ड",
      "form.cancel": "रद्द करें",
      "form.create": "बनाएं",
      "invite.acceptCta": "आमंत्रण स्वीकार करें",
      "invite.acceptError": "आमंत्रण स्वीकार नहीं किया जा सका।",
      "invite.acceptSuccess": "{{workspace}} में शामिल हो गए।",
      "invite.alreadyUsedBody": "यह आमंत्रण पहले ही स्वीकार किया जा चुका है।",
      "invite.alreadyUsedTitle": "आमंत्रण पहले ही उपयोग किया जा चुका है",
      "invite.backToDashboard": "डैशबोर्ड पर वापस जाएं",
      "invite.backToHome": "होम पर वापस जाएं",
      "invite.errorTitle": "आमंत्रण अनुपलब्ध है",
      "invite.expiredBody": "जिस व्यक्ति ने आपको आमंत्रित किया है उससे नया लिंक भेजने के लिए कहें।",
      "invite.expiredTitle": "आमंत्रण समाप्त हो गया",
      "invite.heading": "{{workspace}} में शामिल हों",
      "invite.label": "आमंत्रण",
      "invite.loadError": "यह आमंत्रण लोड नहीं किया जा सका।",
      "invite.redirecting": "आपको आपके वर्कस्पेस पर ले जाया जा रहा है...",
      "invite.signInToAccept": "स्वीकार करने के लिए साइन इन करें",
      "invite.subheading": "आपको {{workspace}} के {{role}} के रूप में आमंत्रित किया गया है।",
      "invite.welcomeTitle": "{{workspace}} में आपका स्वागत है",
      "landing.cta": "अपनी यात्रा शुरू करें",
      "landing.description": "केवल कार्यों से अधिक। आप जो <1>करते हैं</1> उसे उससे जोड़ें जो आप <3>चाहते हैं</3>, और आप जो <5>बन रहे हैं</5>।",
      "landing.tagline": "कर्म से पहचान तक",
      "landing.title": "Align",
      "layer.being": "बनना है",
      "layer.being.subtitle": "पहचान और मूल्य",
      "layer.todo": "करना है",
      "layer.todo.subtitle": "आज के कार्य",
      "layer.want": "इच्छा",
      "layer.want.subtitle": "लक्ष्य और इच्छाएं",
      "members.invite.copyFail": "लिंक कॉपी नहीं किया जा सका।",
      "members.invite.copyLink": "आमंत्रण लिंक कॉपी करें",
      "members.invite.emailPlaceholder": "name@example.com",
      "members.invite.error": "आमंत्रण नहीं भेजा जा सका।",
      "members.invite.linkCopied": "आमंत्रण लिंक क्लिपबोर्ड पर कॉपी हो गया।",
      "members.invite.linkHint": "कॉन्फ़िगर होने पर एक ईमेल भेजा जाता है। आमंत्रण लिंक स्वचालित रूप से कॉपी हो जाता है ताकि आप इसे सीधे साझा कर सकें।",
      "members.invite.revoke": "रद्द करें",
      "members.invite.revokeConfirm": "इस आमंत्रण को रद्द करें? लिंक काम करना बंद कर देगा।",
      "members.invite.revokeError": "आमंत्रण रद्द नहीं किया जा सका।",
      "members.invite.revoked": "आमंत्रण रद्द कर दिया गया।",
      "members.invite.send": "भेजें",
      "members.invite.sent": "आमंत्रण भेजा गया।",
      "members.invite.title": "एक टीम के सदस्य को आमंत्रित करें",
      "members.list.title": "सदस्य ({{count}})",
      "members.list.you": "आप",
      "members.loadError": "सदस्य लोड नहीं किए जा सके।",
      "members.loading": "सदस्य लोड किए जा रहे हैं...",
      "members.pending.title": "लंबित आमंत्रण ({{count}})",
      "members.role.admin": "एडमिन",
      "members.role.manager": "प्रबंधक",
      "members.role.member": "सदस्य",
      "members.title": "सदस्य",
      "mode.corporate": "कॉर्पोरेट",
      "mode.family": "पारिवारिक",
      "mode.personal": "व्यक्तिगत",
      "nav.about": "हमारे बारे में",
      "nav.back": "डैशबोर्ड पर वापस जाएं",
      "nav.calendar": "कैलेंडर",
      "nav.dashboard": "डैशबोर्ड",
      "nav.help": "सहायता",
      "nav.logout": "लॉगआउट",
      "nav.progress": "प्रगति",
      "nav.reflect": "आत्मचिंतन",
      "reflection.empty": "अभी तक कोई आत्मचिंतन नहीं है। ऊपर अपनी यात्रा शुरू करें!",
      "reflection.past": "पिछले आत्मचिंतन",
      "reflection.placeholder": "अपने विचार यहाँ लिखें...",
      "reflection.save": "आत्मचिंतन सहेजें",
      "reflection.saving": "सहेजा जा रहा है...",
      "reflection.subtitle": "रुकें और अपनी यात्रा पर विचार करने के लिए एक क्षण लें",
      "reflection.title": "दैनिक आत्मचिंतन",
      "review.dismiss": "अभी के लिए छुपाएं",
      "review.engage": "इस पर विचार करें",
      "review.label": "साप्ताहिक चेक-इन",
      "review.skipWeek": "यह सप्ताह छोड़ें",
      "review.statsCompleted": "इस सप्ताह {{total}} में से {{done}} संरेखित कार्य पूर्ण हुए",
      "toast.auth.error": "प्रमाणीकरण विफल रहा",
      "toast.being.created": "अस्तित्व बनाया गया",
      "toast.being.deleted": "अस्तित्व हटाया गया",
      "toast.being.error": "अस्तित्व बनाने में विफल",
      "toast.reflection.error": "आत्मचिंतन सहेजने में विफल",
      "toast.reflection.saved": "आत्मचिंतन सहेज लिया गया",
      "toast.session.expired": "सत्र समाप्त हो गया। कृपया फिर से लॉगिन करें।",
      "toast.streak": "सिलसिला: {{count}} दिन!",
      "toast.todo.created": "कार्य बनाया गया",
      "toast.todo.deleted": "कार्य हटाया गया",
      "toast.todo.error": "कार्य बनाने में विफल",
      "toast.want.created": "इच्छा बनाई गई",
      "toast.want.deleted": "इच्छा हटाई गई",
      "toast.want.error": "इच्छा बनाने में विफल",
      "toast.welcome.login": "आपका स्वागत है!",
      "toast.welcome.signup": "Align में आपका स्वागत है!",
      "today.embody": "आत्मसात करें",
      "today.empty": "आज कुछ भी निर्धारित नहीं है। एक कार्य जोड़ें या नीचे सहायक से पूछें।",
      "today.label": "आज",
      "today.next": "अगले कदम",
      "todo.connect.being": "एक 'बनना है' से जोड़ें (वैकल्पिक)",
      "todo.connect.want": "एक 'इच्छा' से जोड़ें (वैकल्पिक)",
      "todo.description.placeholder": "विवरण (वैकल्पिक)",
      "todo.empty": "अभी तक कोई कार्य नहीं है। शुरू करने के लिए एक बनाएं!",
      "todo.title.placeholder": "क्या किया जाना चाहिए?",
      "tour.btn.done": "पूर्ण",
      "tour.btn.next": "आगे",
      "tour.btn.prev": "पीछे",
      "tour.helpTooltip": "सहायता दौरा",
      "tour.step1.desc": "Align आपको यह पाटने में मदद करता है कि आप कौन बनना चाहते हैं और हर दिन क्या करते हैं। आइए यह देखने के लिए 1 मिनट का त्वरित टूर लें कि यह कैसे काम करता है।",
      "tour.step1.title": "Align में आपका स्वागत है",
      "tour.step2.desc": "यह आपकी यात्रा की जड़ है। परिभाषित करें कि आप कौन बनना चाहते हैं या आप किन मूल्यों का अभ्यास करना चाहते हैं (जैसे, 'सीनियर सॉफ्टवेयर डेवलपर' या 'स्वस्थ धावक')।",
      "tour.step2.title": "1. बनना है (पहचान और मूल्य)",
      "tour.step3.desc": "ठोस लक्ष्य निर्धारित करें जो आपकी पहचान का समर्थन करते हैं। उदाहरण के लिए, 'मास्टर डिस्ट्रिब्यूटेड सिस्टम डिज़ाइन' आपकी डेवलपर पहचान का समर्थन करता है।",
      "tour.step3.title": "2. इच्छा (लक्ष्य और इच्छाएं)",
      "tour.step4.desc": "यहाँ तत्काल कार्य बनाएं और उन्हें अपने लक्ष्यों से जोड़ें। जैसे ही आप इन कार्यों को पूरा करते हैं, आपके लक्ष्यों पर प्रगति बार अपने आप अपडेट हो जाएंगे!",
      "tour.step4.title": "3. करना है (आज के कार्य)",
      "tour.step5.desc": "आपका साइडबार आज के लिए आपकी पहचान, आपकी साप्ताहिक समीक्षा और ध्यान केंद्रित करने के लिए शीर्ष 3 उच्च-प्राथमिकता वाले कार्यों को दिखाता है।",
      "tour.step5.title": "आपका दैनिक कॉकपिट",
      "tour.step6.desc": "यहाँ अपने एआई कोच से बात करें। अपने दिन के बारे में आत्मचिंतन लिखें, और एआई स्वचालित रूप से आपके लिए नई पहचान, लक्ष्य और कार्यों को निकाल और जोड़ देगा!",
      "tour.step6.title": "एआई चिंतन और कोच",
      "tour.step7.desc": "अपना दैनिक कार्यक्रम देखने और अनुकूलित करने के लिए 'कैलेंडर' (Calendar) पर क्लिक करें, दैनिक जर्नल प्रविष्टियाँ लिखने के लिए 'आत्मचिंतन' (Reflect) पर क्लिक करें, या अपने विज़ुअल एनालिटिक्स डैशबोर्ड और सिलसिले देखने के लिए 'प्रगति' (Progress) पर क्लिक करें।",
      "tour.step7.title": "शेड्यूल, आत्मचिंतन और प्रगति देखें",
      "tour.calendar.step1.desc": "आपके कैलेंडर in आपका स्वागत है। यहाँ आप एक विज़ुअल टाइमलाइन में अपनी दैनिक गतिविधियों को व्यवस्थित कर सकते हैं।",
      "tour.calendar.step1.title": "डे प्लानर कॉकपिट",
      "tour.calendar.step2.desc": "पहले से कार्यों को शेड्यूल करने या पिछले दिनों को आपने कैसे बिताया इसकी समीक्षा करने के लिए तारीखों के बीच नेविगेट करें।",
      "tour.calendar.step2.title": "तारीख नेविगेशन",
      "tour.calendar.step3.desc": "इस पैनल में आपके सभी सक्रिय पहचान, लक्ष्य और कार्य शामिल हैं जिन्हें अभी तक आज के शेड्यूल में शामिल नहीं किया गया है।",
      "tour.calendar.step3.title": "अनियोजित वस्तुएं",
      "tour.calendar.step4.desc": "अपनी अनियोजित सूची से एक कार्य चुनने और उसके लिए समय ब्लॉक करने के लिए \"+ इस समय में ब्लॉक जोड़ें\" पर क्लिक करें।",
      "tour.calendar.step4.title": "प्रति घंटा समयरेखा",
      "tour.calendar.step5.desc": "कैलेंडर और अपने तीन-कॉलम डैशबोर्ड के बीच स्विच करने के लिए इस बटन पर क्लिक करें।",
      "tour.calendar.step5.title": "व्यू मोड बदलें",
      "want.description.placeholder": "यह आपके लिए क्यों मायने रखता है?",
      "want.empty": "अभी तक कोई लक्ष्य नहीं है। आपकी क्या इच्छा है?",
      "want.progress": "प्रगति",
      "want.title.placeholder": "आप क्या चाहते हैं?",
      "workspace.corporate.createCta": "बनाएं",
      "workspace.corporate.descPlaceholder": "यह वर्कस्पेस किस उद्देश्य के लिए है?",
      "workspace.corporate.firstTime.cta": "वर्कस्पेस बनाएं",
      "workspace.corporate.firstTime.subtitle": "आपकी टीम या संगठन के लिए एक वर्कस्पेस। दृष्टिकोण को OKRs और प्रमुख परिणामों में विभाजित करें। तैयार होने पर सहयोगियों को आमंत्रित करें।",
      "workspace.corporate.firstTime.title": "अपना पहला वर्कस्पेस सेट करें",
      "workspace.corporate.namePlaceholder": "जैसे: एक्मे मार्केटिंग, इंजीनियरिंग पॉड",
      "workspace.corporate.newOption": "नया वर्कस्पेस",
      "workspace.corporate.newSubtitle": "इसे एक नाम दें और आप दृष्टिकोण को कर्म में बदलना शुरू कर सकते हैं।",
      "workspace.corporate.newTitle": "एक वर्कस्पेस बनाएं",
      "workspace.family.createCta": "बनाएं",
      "workspace.family.descPlaceholder": "क्या चीज़ इस परिवार को एक साथ आगे बढ़ाती है?",
      "workspace.family.firstTime.cta": "पारिवारिक वर्कस्पेस बनाएं",
      "workspace.family.firstTime.subtitle": "आपके परिवार के लिए एक साझा स्थान। मूल्यों, इस वर्ष के विषयों और सपनों को एक साथ सहेजें।",
      "workspace.family.firstTime.title": "अपना पारिवारिक वर्कस्पेस सेट करें",
      "workspace.family.namePlaceholder": "जैसे: शर्मा परिवार, हमारा 2026",
      "workspace.family.newOption": "नया पारिवारिक वर्कस्पेस",
      "workspace.family.newSubtitle": "इसे परिवार या साझा अध्याय के नाम पर रखें। आप एक से अधिक में शामिल हो सकते हैं।",
      "workspace.family.newTitle": "एक पारिवारिक वर्कस्पेस बनाएं",
      "calendar.title": "दिनचर्या",
      "calendar.loading": "दिनचर्या लोड हो रही है...",
      "calendar.continued": "जारी:",
      "calendar.until": "({{time}} तक)",
      "calendar.addBlock": "+ इस समय में ब्लॉक जोड़ें",
      "calendar.addBlockPrompt": "इस समय में ब्लॉक जोड़ें",
      "calendar.editSchedule": "कार्यक्रम संपादित करें: {{title}}",
      "calendar.scheduleTitle": "कार्यक्रम: {{title}}",
      "calendar.startTime": "शुरू होने का समय",
      "calendar.duration": "अवधि",
      "calendar.itemType": "आइटम का प्रकार",
      "calendar.description": "विवरण",
      "calendar.unschedule": "सूची से हटाएं",
      "calendar.cancel": "रद्द करें",
      "calendar.update": "अपडेट करें",
      "calendar.schedule": "सूचीबद्ध करें",
      "calendar.hours": "घंटे",
      "calendar.mins": "मिनट",
      "calendar.custom": "कस्टम...",
      "calendar.unscheduledItems": "अनिर्धारित आइटम",
      "calendar.beings": "बनना है (पहचान और आदतें)",
      "calendar.wants": "चाहते हैं (लक्ष्य और इच्छाएं)",
      "calendar.todos": "करना है (आज के कार्य)",
      "calendar.noneUnscheduled": "कोई अनिर्धारित आइटम नहीं",
      "welcome.success": "बोर्ड पर आपका स्वागत है! आपका कार्यक्षेत्र तैयार है।",
      "welcome.error": "कार्यक्षेत्र को आरंभ करने में विफल। कृपया पुन: प्रयास करें।",
      "welcome.trial.title": "Align Pro में आपका स्वागत है",
      "welcome.trial.subtitle": "आपका 14-दिन का निःशुल्क परीक्षण सक्रिय है। अपना पहला लक्ष्य कैस्केड शुरू करने के लिए एक फोकस क्षेत्र चुनें।",
      "welcome.focus.section_title": "अपना प्राथमिक फोकस क्षेत्र चुनें:",
      "welcome.focus.health.title": "स्वास्थ्य और जीवन शक्ति",
      "welcome.focus.health.desc": "शारीरिक ऊर्जा, स्वस्थ आदतें और दैनिक व्यायाम का निर्माण करें।",
      "welcome.focus.career.title": "करियर और फोकस",
      "welcome.focus.career.desc": "उत्पादकता बढ़ाएं, परियोजना लक्ष्यों को प्राप्त करें और कार्य योजना बनाएं।",
      "welcome.focus.mindfulness.title": "माइंडफुलनेस और उपस्थिति",
      "welcome.focus.mindfulness.desc": "दैनिक आत्म-चिंतन विकसित करें, स्क्रीन समय कम करें और वर्तमान में रहें।",
      "welcome.focus.blank.title": "स्वतंत्र रूप से अन्वेषण करें (खाली)",
      "welcome.focus.blank.desc": "एक साफ पन्ने से शुरुआत करें। शुरू से ही अपना खुद का कस्टम कैस्केड बनाएं।",
      "welcome.trial.highlight": "प्रो ट्रायल सक्रिय",
      "welcome.trial.highlight_desc": "आपके पास लाइव एआई कोचिंग, पारिवारिक/कॉर्पोरेट कार्यक्षेत्र और असीमित लक्ष्यों तक पूर्ण पहुंच है। कोई क्रेडिट कार्ड आवश्यक नहीं है।",
      "welcome.loading": "कार्यक्षेत्र शुरू किया जा रहा है...",
      "welcome.trial.cta": "मेरे कार्यक्षेत्र में प्रवेश करें",
      "welcome.trial.guarantee": "कोई स्वचालित शुल्क नहीं।",
      "tour.step_stalled.title": "रुके हुए लक्ष्य संकेत",
      "tour.step_stalled.desc_pro": "जब लक्ष्य गति खो देते हैं, तो यह कार्ड आपको उन्हें संग्रहीत करने या आपके एआई कोच के साथ चिंतन करने में मदद करता है।",
      "tour.step_stalled.desc_starter": "जब लक्ष्य गति खो देते हैं, तो यह कार्ड आपको उन्हें संग्रहीत करने या गतिरोध तोड़ने के लिए एक छोटा तत्काल कार्य जोड़ने में मदद करता है।",
      "dialog.delete.being.title": "क्या इस अस्तित्व को हटाना चाहते हैं?",
      "dialog.delete.being.desc": "इस पहचान के साथ सभी जुड़े लक्ष्य और कार्य भी हटा दिए जाएंगे।",
      "dialog.delete.want.title": "क्या इस लक्ष्य को हटाना चाहते हैं?",
      "dialog.delete.want.desc": "इस लक्ष्य के साथ सभी जुड़े कार्य भी हटा दिए जाएंगे।",
      "dialog.delete.todo.title": "क्या इस कार्य को हटाना चाहते हैं?",
      "dialog.delete.todo.desc": "यह कार्य स्थायी रूप से हटा दिया जाएगा।",
      "dialog.delete.confirm": "हटाएं",
      "dialog.delete.cancel": "रद्द करें"
    }
  },
  mr: {
    translation: {
      "about.back": "मागे",
      "about.framework.be.desc": "तुमची ओळख विधाने, मूलभूत मूल्ये आणि सवयी यावर लक्ष केंद्रित करते.",
      "about.framework.be.title": "बनायचे आहे (ओळख)",
      "about.framework.do.desc": "तुमच्या दैनंदिन कामांचे आणि तत्काळ सूचींचे नियोजन करते.",
      "about.framework.do.title": "करायचे आहे (कृती)",
      "about.framework.title": "मूलभूत चौकट",
      "about.framework.want.desc": "तुमच्या ओळखीला समर्थन देणारी वास्तविक ध्येये आणि आकांक्षा दर्शवते.",
      "about.framework.want.title": "इच्छा (ध्येय)",
      "about.modes.corporate.desc": "व्यावसायिक टीम नियोजन, कंपनीची दृष्टी आणि OKRs साठी.",
      "about.modes.corporate.title": "कॉर्पोरेट जागा",
      "about.modes.family.desc": "सामायिक कौटुंबिक मूल्ये, आमंत्रणे आणि कौटुंबिक व्हिजन बोर्डसाठी.",
      "about.modes.family.title": "कौटुंबिक जागा",
      "about.modes.personal.desc": "खाजगी सवयी, सातत्य आणि दैनिक आत्मचिंतनासाठी.",
      "about.modes.personal.title": "वैयक्तिक जागा",
      "about.modes.title": "एक चौकट, तीन वर्कस्पेस",
      "about.philosophy.body": "Align तुम्हाला दैनंदिन कामांना तुमच्या दीर्घकालीन ध्येयांशी आणि तुम्ही काय बनत आहात याच्याशी जोडून उद्देशपूर्ण जीवन जगण्यास मदत करते.",
      "about.philosophy.title": "आमचे तत्वज्ञान",
      "about.tagline": "कृतीतून ओळखीकडे",
      "about.title": "Align बद्दल",
      "about.values.calm.desc": "डिजिटल गोंधळ कमी करण्यासाठी डिझाइन केलेले एक साधे यूजर इंटरफेस.",
      "about.values.calm.title": "शांततापूर्ण फोकस",
      "about.values.intentionality.desc": "महत्त्वाच्या गोष्टींवर लक्ष केंद्रित करण्यासाठी निरर्थक कामे दूर करणे.",
      "about.values.intentionality.title": "उद्देश्यपूर्णता",
      "about.values.reflection.desc": "प्रगतीचा मागोवा घेण्यासाठी थांबा आणि विचार करा.",
      "about.values.reflection.title": "आत्मचिंतन",
      "about.values.title": "आमचे डिझाइन सिद्धांत",
      "aiChat.commit.error": "गोष्टी जतन करण्यात अयशस्वी.",
      "aiChat.commit.success": "तुमच्या प्रणालीमध्ये {{items}} गोष्टी जोडल्या गेल्या.",
      "aiChat.continue.hint": "चर्चा सुरू ठेवण्यासाठी उत्तर द्या. पाठवण्यासाठी ⌘ + Enter.",
      "aiChat.continue.placeholder": "वरील प्रश्नाचे उत्तर द्या, किंवा अधिक जोडा...",
      "aiChat.empty": "मला जोडण्यासाठी काही आढळले नाही. कृपया ध्येय किंवा कामांविषयी अधिक स्पष्ट लिहा.",
      "aiChat.extract.error": "एआय प्रक्रिया करू शकले नाही. पुन्हा प्रयत्न करा?",
      "aiChat.fab.label": "Align एजंट",
      "aiChat.hint": "पाठवण्यासाठी ⌘ + Enter दाबा. बोलण्यासाठी माईकवर टॅप करा.",
      "aiChat.listening": "ऐकत आहे… नैसर्गिकरित्या बोला, मी ते व्यवस्थित करेन.",
      "aiChat.panel.close": "बंद करा",
      "aiChat.placeholder.examples.0": "तुमच्या मनात काय आहे ते सांगा — ध्येय, कामे, तुम्हाला काय बनायचे आहे...",
      "aiChat.placeholder.examples.1": "प्रयत्न करा: \"मला एक संयमी पालक बनायचे आहे आणि माझ्या मुलांसोबत महिन्यातून एक पुस्तक वाचायचे आहे.\"",
      "aiChat.placeholder.examples.2": "प्रयत्न करा: \"ऑक्टोबरमध्ये हाफ मॅरेथॉन धावणे. या वीकेंडला शूज खरेदी करणे.\"",
      "aiChat.placeholder.examples.3": "प्रयत्न करा: \"खूप थकल्यासारखे वाटत आहे. मला संध्याकाळी ६ वाजता काम थांबवण्याची नितांत गरज आहे.\"",
      "aiChat.reflections": "आत्मचिंतन",
      "aiChat.review.commit": "माझ्या प्रणालीत जोडा",
      "aiChat.review.followup": "फॉलो-अप",
      "aiChat.review.nothingSelected": "जोडण्यासाठी किमान एक गोष्ट निवडा.",
      "aiChat.review.title": "मला काय सापडले त्याचे पुनरावलोकन करा",
      "aiChat.thread.reset": "पुन्हा सुरू करा",
      "aiChat.voice.error": "व्हॉईस इनपुट अयशस्वी झाले.",
      "aiChat.voice.tooltip": "टाईप करण्याऐवजी बोला",
      "aiChat.voice.unsupported": "या ब्राउझरमध्ये व्हॉईस इनपुट समर्थित नाही.",
      "analytics.being.label": "बनायचे आहे",
      "analytics.being.subtitle": "ओळख आणि मूल्ये",
      "analytics.motivation.high": "तुमची प्रगती उत्कृष्ट आहे. तुमच्या कृती ध्येयांशी सुसंगत ठेवत राहा।",
      "analytics.motivation.low": "प्रवासाची सुरुवात एका पावलाने होते. आजच सुरू करा।",
      "analytics.motivation.medium": "प्रत्येक लहान कृती तुम्हाला हव्या असलेल्या ओळखीच्या जवळ नेते।",
      "analytics.reflections": "आत्मचिंतन",
      "analytics.reflections.entries": "जर्नल नोंदी",
      "analytics.streaks.active": "सक्रिय सातत्य",
      "analytics.streaks.longest": "सर्वात मोठे: {{count}} दिवस",
      "analytics.subtitle": "कृतीतून ओळखीकडच्या प्रवासाचा मागोवा घ्या",
      "analytics.tasks.completed": "पूर्ण झालेली कामे",
      "analytics.tasks.rate": "{{rate}}% पूर्णता दर",
      "analytics.title": "तुमची प्रगती",
      "analytics.todo.label": "करायचे आहे",
      "analytics.todo.subtitle": "कृती आणि कामे",
      "analytics.want.label": "इच्छा",
      "analytics.want.subtitle": "ध्येय आणि इच्छा",
      "analytics.wants.completed": "{{count}} पूर्ण",
      "analytics.wants.progress": "इच्छांची प्रगती",
      "auth.email": "ईमेल",
      "auth.google": "गुगलसह पुढे जा",
      "auth.loading": "कृपया प्रतीक्षा करा...",
      "auth.loading.google": "कनेक्ट होत आहे...",
      "auth.loading.login": "साइन इन होत आहे...",
      "auth.loading.signup": "खाते तयार होत आहे...",
      "auth.login": "पुन्हा स्वागत आहे",
      "auth.name": "नाव",
      "auth.or": "किंवा",
      "auth.password": "पासवर्ड",
      "auth.signup": "खाते तयार करा",
      "auth.submit.login": "साइन इन करा",
      "auth.submit.signup": "खाते तयार करा",
      "auth.toggle.login": "खाते नाही? साइन अप करा",
      "auth.toggle.signup": "आधीच खाते आहे? साइन इन करा",
      "auth.verify.backToHome": "मुख्यपृष्ठावर परत जा",
      "auth.verify.error": "पडताळणी अयशस्वी. लिंक कालबाह्य झाली असावी किंवा अवैध आहे.",
      "auth.verify.errorTitle": "पडताळणी अयशस्वी",
      "auth.verify.goToLogin": "लॉगिनवर जा",
      "auth.verify.needed": "लॉगिन करण्यापूर्वी कृपया तुमचा ईमेल पडताळणी करा.",
      "auth.verify.noToken": "कोणताही पडताळणी टोकन दिला नाही.",
      "auth.verify.resend": "ईमेल पुन्हा पाठवा",
      "auth.verify.resentBody": "त्या ईमेलसाठी खाते अस्तित्वात असल्यास, नवीन पडताळणी लिंक पाठवली गेली आहे.",
      "auth.verify.successBody": "तुमचा ईमेल यशस्वीरित्या पडताळला गेला आहे. आता तुम्ही लॉग इन करू शकता.",
      "auth.verify.successTitle": "खाते पडताळले गेले!",
      "auth.verify.verifyingBody": "आम्ही तुमच्या ईमेल पत्त्याची पुष्टी करेपर्यंत कृपया प्रतीक्षा करा...",
      "auth.verify.verifyingTitle": "ईमेलची पडताळणी करत आहे",
      "being.days": "दिवस",
      "being.description.placeholder": "तुमच्या या पैलूचे वर्णन करा...",
      "being.empty": "तुम्ही काय बनत आहात?",
      "being.practice": "आज सराव करा",
      "being.streak": "सातत्य",
      "being.title.placeholder": "तुम्ही काय बनत आहात?",
      "being.type.habit": "सवय",
      "being.type.identity": "ओळख",
      "being.type.value": "मूल्य",
      "corporate.firstTime.cta": "वर्कस्पेस तयार करा",
      "corporate.firstTime.subtitle": "वर्कस्पेस म्हणजे अशी जागा जिथे तुम्ही सामायिक ध्येये आणि निकालांसह टीम किंवा कुटुंबाला सुसंगत ठेवता.",
      "corporate.firstTime.title": "तुमचा पहिला वर्कस्पेस सेट करा",
      "corporate.goal.createError": "जोडता आले नाही.",
      "corporate.goal.created": "जोडले गेले.",
      "corporate.goal.deleteConfirm": "हे ध्येय काढू इच्छिता? याच्याशी जोडलेली इतर उप-कामे देखील काढली जातील.",
      "corporate.goal.deleteError": "काढता आले नाही.",
      "corporate.goal.deleted": "काढले गेले.",
      "corporate.goal.progress": "प्रगती",
      "corporate.goal.updateError": "प्रगती अपडेट करता आली नाही.",
      "corporate.goals.fetchError": "ध्येये लोड होऊ शकले नाहीत.",
      "corporate.kr.add": "महत्त्वाचा निकाल जोडा",
      "corporate.kr.descPlaceholder": "पर्यायी संदर्भ.",
      "corporate.kr.titlePlaceholder": "कोणता मोजण्याजोगा निकाल OKR सिद्ध करतो?",
      "corporate.level.kr": "महत्त्वाचे निकाल",
      "corporate.level.okr": "OKR",
      "corporate.level.vision": "दृष्टी",
      "corporate.loading": "तुमचे वर्कस्पेस लोड होत आहेत...",
      "corporate.okr.add": "OKR जोडा",
      "corporate.okr.descPlaceholder": "पर्यायी संदर्भ.",
      "corporate.okr.titlePlaceholder": "कोणते उद्दिष्ट या दृष्टीला साध्य करण्यास मदत करेल?",
      "corporate.type.corporate": "कॉर्पोरेट",
      "corporate.type.corporateDesc": "टीम किंवा संस्था. दृष्टी → OKRs → महत्त्वाचे निकाल.",
      "corporate.type.family": "कौटुंबिक",
      "corporate.type.familyDesc": "कुटुंब. सामायिक मूल्ये आणि वार्षिक विषय.",
      "corporate.vision.add": "दृष्टी जोडा",
      "corporate.vision.descPlaceholder": "पर्यायी संदर्भ, का.",
      "corporate.vision.empty": "अजून कोणतीही दृष्टी निश्चित नाही. वर्कस्पेसच्या उद्दिष्टाविषयी एका सोप्या विधानाने सुरुवात करा.",
      "corporate.vision.titlePlaceholder": "या वर्कस्पेसला काय साध्य करायचे आहे?",
      "corporate.workspace.create": "तयार करा",
      "corporate.workspace.createError": "वर्कस्पेस तयार करता आला नाही.",
      "corporate.workspace.created": "वर्कस्पेस तयार केला.",
      "corporate.workspace.descLabel": "वर्णन (पर्यायी)",
      "corporate.workspace.descPlaceholder": "हा वर्कस्पेस कोणत्या उद्देशासाठी आहे?",
      "corporate.workspace.nameLabel": "नाव",
      "corporate.workspace.namePlaceholder": "उदा. Acme Marketing, जोशी कुटुंब",
      "corporate.workspace.new": "नवीन वर्कस्पेस",
      "corporate.workspace.newSubtitle": "नाव द्या आणि ध्येयांना कृतीत आणण्यास सुरुवात करा.",
      "corporate.workspace.newTitle": "एक वर्कस्पेस तयार करा",
      "corporate.workspace.typeLabel": "प्रकार",
      "corporate.workspaces.fetchError": "वर्कस्पेस लोड होऊ शकले नाहीत.",
      "family.cat.annual_themes.contentPlaceholder": "हा विषय कसा दिसतो? वर्षाच्या शेवटी हे कसे सिद्ध होईल?",
      "family.cat.annual_themes.empty": "या वर्षाचा विषय काय आहे? एक किंवा दोन निवडा — दहा नाही.",
      "family.cat.annual_themes.tagline": "या वर्षाला आकार देणारे विषय. एक शब्द किंवा एक वाक्य.",
      "family.cat.annual_themes.title": "हे वर्ष",
      "family.cat.annual_themes.titlePlaceholder": "उदा. मैदानी उपक्रमांचे वर्ष, ऐकण्याचे वर्ष",
      "family.cat.dreams.contentPlaceholder": "हे स्वप्न का? याने काय वाटेल?",
      "family.cat.dreams.empty": "असे काहीतरी लिहा जे कुटुंबात कोणाही उघडपणे बोलण्याचे धाडस केले नाही.",
      "family.cat.dreams.tagline": "दीर्घकालीन स्वप्ने. कोणतीही अंतिम मुदत नाही, कोणतीही लाज नाही.",
      "family.cat.dreams.title": "स्वप्ने",
      "family.cat.dreams.titlePlaceholder": "उदा. न्यूझीलंडची सफर, झाडावर घर बांधणे",
      "family.cat.values.contentPlaceholder": "हे मूल्य आमच्यासाठी व्यवहारात कसे दिसते?",
      "family.cat.values.empty": "अजून कोणतेही मूल्य लिहिलेले नाही. सर्वात महत्त्वाच्या मूल्याने सुरुवात करा.",
      "family.cat.values.tagline": "कुटुंब कशासाठी उभे आहे. मूलभूत गोष्टी.",
      "family.cat.values.title": "मूल्ये",
      "family.cat.values.titlePlaceholder": "उदा. प्रामाणिकपणा, साहस, सोबत देणे",
      "family.createError": "जोडता आले नाही.",
      "family.created": "जोडले गेले.",
      "family.deleteConfirm": "व्हिजन बोर्डवरून हे काम काढायचे?",
      "family.deleteError": "काढता आले नाही.",
      "family.deleted": "काढले गेले.",
      "family.fetchError": "व्हिजन बोर्ड लोड करता आला नाही.",
      "family.loading": "बोर्ड लोड होत आहे...",
      "family.subtitle": "कौटुंबिक व्हिजन बोर्ड",
      "form.cancel": "रद्द करा",
      "form.create": "तयार करा",
      "invite.acceptCta": "आमंत्रण स्वीकारा",
      "invite.acceptError": "आमंत्रण स्वीकारता आले नाही.",
      "invite.acceptSuccess": "{{workspace}} मध्ये सामील झाले.",
      "invite.alreadyUsedBody": "हे आमंत्रण आधीच स्वीकारले गेले आहे.",
      "invite.alreadyUsedTitle": "आमंत्रण आधीच वापरले गेले आहे",
      "invite.backToDashboard": "डॅशबोर्डवर परत जा",
      "invite.backToHome": "मुख्यपृष्ठावर परत जा",
      "invite.errorTitle": "आमंत्रण उपलब्ध नाही",
      "invite.expiredBody": "ज्यांनी आमंत्रित केले आहे त्यांना नवीन लिंक पाठवण्यास सांगा.",
      "invite.expiredTitle": "आमंत्रण कालबाह्य झाले",
      "invite.heading": "{{workspace}} मध्ये सामील व्हा",
      "invite.label": "आमंत्रण",
      "invite.loadError": "हे आमंत्रण लोड करता आले नाही.",
      "invite.redirecting": "तुम्हाला वर्कस्पेसवर नेले जात आहे...",
      "invite.signInToAccept": "स्वीकारण्यासाठी साइन इन करा",
      "invite.subheading": "तुम्हाला {{workspace}} चे {{role}} म्हणून आमंत्रित केले आहे.",
      "invite.welcomeTitle": "{{workspace}} मध्ये आपले स्वागत आहे",
      "landing.cta": "तुमचा प्रवास सुरू करा",
      "landing.description": "केवळ कामांपेक्षा अधिक. तुम्ही जे <1>करता</1> त्याला तुम्ही जे <3>इच्छिता</3> त्याच्याशी आणि तुम्ही जे <5>बनत आहात</5> त्याच्याशी जोडा.",
      "landing.tagline": "कृतीतून ओळखीकडे",
      "landing.title": "Align",
      "layer.being": "बनायचे आहे",
      "layer.being.subtitle": "ओळख आणि मूल्ये",
      "layer.todo": "करायचे आहे",
      "layer.todo.subtitle": "आजच्या कृती",
      "layer.want": "इच्छा",
      "layer.want.subtitle": "ध्येय आणि इच्छा",
      "members.invite.copyFail": "लिंक कॉपी करता आली नाही.",
      "members.invite.copyLink": "आमंत्रण लिंक कॉपी करा",
      "members.invite.emailPlaceholder": "name@example.com",
      "members.invite.error": "आमंत्रण पाठवता आले नाही.",
      "members.invite.linkCopied": "आमंत्रण लिंक क्लिपबोर्डवर कॉपी केली.",
      "members.invite.linkHint": "कॉन्फिगर असल्यास ईमेल पाठवला जातो. आमंत्रण लिंक ऑटो-कॉपी होते जेणेकरून थेट शेअर करता येईल.",
      "members.invite.revoke": "रद्द करा",
      "members.invite.revokeConfirm": "हे आमंत्रण रद्द करायचे? लिंक काम करणे बंद करेल.",
      "members.invite.revokeError": "आमंत्रण रद्द करता आले नाही.",
      "members.invite.revoked": "आमंत्रण रद्द केले.",
      "members.invite.send": "पाठवा",
      "members.invite.sent": "आमंत्रण पाठवले.",
      "members.invite.title": "सहकाऱ्याला आमंत्रित करा",
      "members.list.title": "सदस्य ({{count}})",
      "members.list.you": "तुम्ही",
      "members.loadError": "सदस्य लोड होऊ शकले नाहीत.",
      "members.loading": "सदस्य लोड होत आहेत...",
      "members.pending.title": "लंबित आमंत्रणे ({{count}})",
      "members.role.admin": "अ‍ॅडमिन",
      "members.role.manager": "व्यवस्थापक",
      "members.role.member": "सदस्य",
      "members.title": "सदस्य",
      "mode.corporate": "कॉर्पोरेट",
      "mode.family": "कौटुंबिक",
      "mode.personal": "वैयक्तिक",
      "nav.about": "आमच्याबद्दल",
      "nav.back": "डॅशबोर्डवर परत जा",
      "nav.calendar": "कॅलेंडर",
      "nav.dashboard": "डॅशबोर्ड",
      "nav.help": "मदत",
      "nav.logout": "लॉगआउट",
      "nav.progress": "प्रगती",
      "nav.reflect": "आत्मचिंतन",
      "reflection.empty": "अजून कोणतेही आत्मचिंतन नाही. वरून तुमचा प्रवास सुरू करा!",
      "reflection.past": "मागील आत्मचिंतन",
      "reflection.placeholder": "तुमचे विचार येथे लिहा...",
      "reflection.save": "आत्मचिंतन जतन करा",
      "reflection.saving": "जतन होत आहे...",
      "reflection.subtitle": "थांबा आणि तुमच्या प्रवासावर विचार करण्यासाठी एक क्षण घ्या",
      "reflection.title": "दैनिक आत्मचिंतन",
      "review.dismiss": "आता लपवा",
      "review.engage": "यावर विचार करा",
      "review.label": "साप्ताहिक चेक-इन",
      "review.skipWeek": "हा आठवडा वगळा",
      "review.statsCompleted": "या आठवड्यात {{total}} पैकी {{done}} सुसंगत कामे पूर्ण झाली",
      "toast.auth.error": "प्रमाणीकरण अयशस्वी",
      "toast.being.created": "अस्तित्व तयार केले",
      "toast.being.deleted": "अस्तित्व काढले",
      "toast.being.error": "अस्तित्व तयार करण्यात अयशस्वी",
      "toast.reflection.error": "आत्मचिंतन जतन करण्यात अयशस्वी",
      "toast.reflection.saved": "आत्मचिंतन जतन केले",
      "toast.session.expired": "सत्र संपले. कृपया पुन्हा लॉगिन करा.",
      "toast.streak": "सातत्य: {{count}} दिवस!",
      "toast.todo.created": "काम तयार केले",
      "toast.todo.deleted": "काम काढले",
      "toast.todo.error": "काम तयार करण्यात अयशस्वी",
      "toast.want.created": "इच्छा तयार केली",
      "toast.want.deleted": "इच्छा काढली",
      "toast.want.error": "इच्छा तयार करण्यात अयशस्वी",
      "toast.welcome.login": "पुन्हा स्वागत आहे!",
      "toast.welcome.signup": "Align मध्ये आपले स्वागत आहे!",
      "today.embody": "अंगिकार करा",
      "today.empty": "आज काहीही नियोजित नाही. नवीन काम जोडा किंवा खालील सहाय्यकाला विचारा.",
      "today.label": "आज",
      "today.next": "पुढील पावले",
      "todo.connect.being": "एखाद्या अस्तित्वाशी जोडा (पर्यायी)",
      "todo.connect.want": "एखाद्या इच्छेशी जोडा (पर्यायी)",
      "todo.description.placeholder": "तपशील (पर्यायी)",
      "todo.empty": "अजून एकही काम नाही. सुरू करण्यासाठी एक तयार करा!",
      "todo.title.placeholder": "काय करणे आवश्यक आहे?",
      "tour.btn.done": "पूर्ण",
      "tour.btn.next": "पुढे",
      "tour.btn.prev": "मागे",
      "tour.helpTooltip": "मार्गदर्शक प्रवास",
      "tour.step1.desc": "Align तुम्हाला हे समजण्यास मदत करते की तुम्हाला कोण बनायचे आहे आणि तुम्ही दररोज काय करता. ते कसे कार्य करते हे पाहण्यासाठी १ मिनिटाचा छोटा प्रवास करूया.",
      "tour.step1.title": "Align मध्ये आपले स्वागत आहे",
      "tour.step2.desc": "हा तुमच्या प्रवासाचा पाया आहे. तुम्हाला कोण बनायचे आहे किंवा कोणत्या मूल्यांचा सराव करायचा आहे ते परिभाषित करा (उदा. 'वरिष्ठ सॉफ्टवेअर डेव्हलपर' किंवा 'धावपटू').",
      "tour.step2.title": "१. बनायचे आहे (ओळख आणि मूल्ये)",
      "tour.step3.desc": "तुमच्या ओळखीला पूरक ठरणारी ध्येये निश्चित करा. उदा. 'मास्टर डिस्ट्रिब्यूटेड सिस्टीम डिझाइन' तुमच्या डेव्हलपर ओळखीला पूरक आहे.",
      "tour.step3.title": "२. इच्छा (ध्येय आणि इच्छा)",
      "tour.step4.desc": "येथे तत्काळ कामे तयार करा आणि त्यांना ध्येयाशी जोडा. तुम्ही कामे पूर्ण करताच ध्येयांची प्रगती आपोआप वाढेल!",
      "tour.step4.title": "३. करायचे आहे (आजची कामे)",
      "tour.step5.desc": "तुमचा बाजूचा पॅनेल आजची तुमची मुख्य ओळख, तुमची साप्ताहिक पुनरावलोकन आणि लक्ष केंद्रित करण्यासाठी पहिल्या ३ उच्च-प्राधान्य कामांना दर्शवतो.",
      "tour.step5.title": "तुमचा दैनिक कॉकपिट",
      "tour.step6.desc": "येथे तुमच्या एआय मार्गदर्शकाशी बोला. तुमच्या दिवसाविषयी आत्मचिंतन लिहा, आणि एआय आपोआप नवीन ओळख, ध्येय आणि कामे तयार करेल!",
      "tour.step6.title": "एआय आत्मचिंतन आणि मार्गदर्शक",
      "tour.step7.desc": "तुमचे दैनिक वेळापत्रक पाहण्यासाठी आणि सानुकूलित करण्यासाठी 'कैलेंडर' (Calendar) वर क्लिक करा, दैनिक जर्नल लिहिण्यासाठी 'आत्मचिंतन' (Reflect) वर क्लिक करा, किंवा तुमची प्रगती आणि सातत्य दर्शवणारा आलेख पाहण्यासाठी 'प्रगती' (Progress) वर क्लिक करा।",
      "tour.step7.title": "वेळापत्रक, आत्मचिंतन आणि प्रगती पहा",
      "tour.calendar.step1.desc": "तुमच्या कॅलेंडरमध्ये आपले स्वागत आहे. येथे तुम्ही तुमच्या रोजच्या उपक्रमांचे नियोजन एका आलेखामध्ये करू शकता।",
      "tour.calendar.step1.title": "दैनिक वेळापत्रक कक्ष",
      "tour.calendar.step2.desc": "कामांचे आगाऊ नियोजन करण्यासाठी किंवा मागील दिवस कसे घालवले हे पाहण्यासाठी वेगवेगळ्या तारखांवर जा।",
      "tour.calendar.step2.title": "दिनांक नेव्हिगेशन",
      "tour.calendar.step3.desc": "या पॅनेलमध्ये तुमच्या सर्व सक्रिय ओळख, ध्येय आणि कामे आहेत ज्यांचा आजच्या वेळापत्रकात समावेश केलेला नाही।",
      "tour.calendar.step3.title": "अनियोजित गोष्टी",
      "tour.calendar.step4.desc": "तुमच्या अनियोजित कामांच्या यादीमधून काम निवडण्यासाठी आणि त्या वेळेत ब्लॉक करण्यासाठी \"+ या वेळेत ब्लॉक जोडा\" वर क्लिक करा।",
      "tour.calendar.step4.title": "तासवार वेळापत्रक",
      "tour.calendar.step5.desc": "कॅलेंडर आणि तुमच्या तीन-कॉलम डॅशबोर्डमध्ये स्विच करण्यासाठी या बटणावर क्लिक करा।",
      "tour.calendar.step5.title": "व्ह्यू मोड बदला",
      "want.description.placeholder": "हे तुमच्यासाठी का महत्त्वाचे आहे?",
      "want.empty": "अजून कोणतीही ध्येये नाहीत. तुमची काय इच्छा आहे?",
      "want.progress": "प्रगती",
      "want.title.placeholder": "तुम्हाला काय हवे आहे?",
      "workspace.corporate.createCta": "तयार करा",
      "workspace.corporate.descPlaceholder": "हा वर्कस्पेस कोणत्या उद्देशासाठी आहे?",
      "workspace.corporate.firstTime.cta": "वर्कस्पेस तयार करा",
      "workspace.corporate.firstTime.subtitle": "तुमच्या टीम किंवा संस्थेसाठी वर्कस्पेस. ध्येयांचे OKRs आणि महत्त्वाच्या निकालांमध्ये विभाजन करा. तयार असताना सहकाऱ्यांना आमंत्रित करा.",
      "workspace.corporate.firstTime.title": "तुमचा पहिला वर्कस्पेस सेट करा",
      "workspace.corporate.namePlaceholder": "उदा. Acme Marketing, Engineering Pod",
      "workspace.corporate.newOption": "नवीन वर्कस्पेस",
      "workspace.corporate.newSubtitle": "नाव द्या आणि तुम्ही ध्येयांना कृतीत आणण्यास सुरुवात करू शकता.",
      "workspace.corporate.newTitle": "एक वर्कस्पेस तयार करा",
      "workspace.family.createCta": "तयार करा",
      "workspace.family.descPlaceholder": "कोणती गोष्ट या कुटुंबाला एकत्र पुढे नेते?",
      "workspace.family.firstTime.cta": "कौटुंबिक वर्कस्पेस तयार करा",
      "workspace.family.firstTime.subtitle": "तुमच्या कुटुंबासाठी एक सामायिक जागा. मूल्ये, वर्षाचे विषय आणि स्वप्ने एकत्र जतन करा.",
      "workspace.family.firstTime.title": "तुमचा कौटुंबिक वर्कस्पेस सेट करा",
      "workspace.family.namePlaceholder": "उदा. जोशी कुटुंब, आमचे २०२६",
      "workspace.family.newOption": "नवीन कौटुंबिक वर्कस्पेस",
      "workspace.family.newSubtitle": "कुटुंब किंवा सामायिक अध्यायाच्या नावावर ठेवा. तुम्ही एकापेक्षा जास्त ठिकाणी सामील करू शकता.",
      "workspace.family.newTitle": "एक कौटुंबिक वर्कस्पेस तयार करा",
      "calendar.title": "दैनिक वेळापत्रक",
      "calendar.loading": "वेळापत्रक लोड होत आहे...",
      "calendar.continued": "पुढे चालू:",
      "calendar.until": "({{time}} पर्यंत)",
      "calendar.addBlock": "+ या वेळेत ब्लॉक जोडा",
      "calendar.addBlockPrompt": "या वेळेत ब्लॉक जोडा",
      "calendar.editSchedule": "वेळापत्रक संपादित करा: {{title}}",
      "calendar.scheduleTitle": "वेळापत्रक: {{title}}",
      "calendar.startTime": "सुरुवात वेळ",
      "calendar.duration": "कालावधी",
      "calendar.itemType": "प्रकार",
      "calendar.description": "वर्णन",
      "calendar.unschedule": "वेळापत्रकातून काढा",
      "calendar.cancel": "रद्द करा",
      "calendar.update": "अपडेट करा",
      "calendar.schedule": "नियोजन करा",
      "calendar.hours": "तास",
      "calendar.mins": "मिनिटे",
      "calendar.custom": "सानुकूल...",
      "calendar.unscheduledItems": "अनियोजित गोष्टी",
      "calendar.beings": "बनायचे आहे (ओळख आणि सवयी)",
      "calendar.wants": "इच्छा (ध्येय आणि आकांक्षा)",
      "calendar.todos": "करायचे आहे (आजचे काम)",
      "calendar.noneUnscheduled": "कोणतीही अनियोजित गोष्ट नाही",
      "welcome.success": "तुमचे स्वागत आहे! तुमचे कार्यक्षेत्र तयार आहे।",
      "welcome.error": "कार्यक्षेत्र सुरू करण्यात अपयश आले. कृपया पुन्हा प्रयत्न करा.",
      "welcome.trial.title": "Align Pro मध्ये आपले स्वागत आहे",
      "welcome.trial.subtitle": "तुमची 14-दिवसांची विनामूल्य चाचणी सक्रिय आहे. तुमचे पहिले ध्येय कॅस्केड सुरू करण्यासाठी एक फोकस क्षेत्र निवडा.",
      "welcome.focus.section_title": "तुमचे प्राथमिक फोकस क्षेत्र निवडा:",
      "welcome.focus.health.title": "आरोग्य आणि चैतन्य",
      "welcome.focus.health.desc": "शारीरिक ऊर्जा, निरोगी सवयी आणि रोजचा व्यायाम तयार करा.",
      "welcome.focus.career.title": "करिअर आणि फोकस",
      "welcome.focus.career.desc": "उत्पादकता वाढवा, प्रकल्प उद्दिष्टे साध्य करा आणि कामाचे नियोजन करा.",
      "welcome.focus.mindfulness.title": "माइंडफुलनेस आणि उपस्थिती",
      "welcome.focus.mindfulness.desc": "दैनिक आत्म-चिंतन विकसित करा, स्क्रीन वेळ कमी करा आणि वर्तमानात राहा.",
      "welcome.focus.blank.title": "मुक्तपणे एक्सप्लोर करा (कोरे)",
      "welcome.focus.blank.desc": "एका कोऱ्या पानापासून सुरुवात करा. सुरवातीपासूनच तुमचे स्वतःचे कस्टम कॅस्केड तयार करा.",
      "welcome.trial.highlight": "प्रो ट्रायल सक्रिय",
      "welcome.trial.highlight_desc": "तुमच्याकडे लाइव्ह एआय कोचिंग, कौटुंबिक/कॉर्पोरेट कार्यक्षेत्र आणि अमर्याद उद्दिष्टे यावर पूर्ण प्रवेश आहे. कोणतीही क्रेडिट कार्ड आवश्यक नाही.",
      "welcome.loading": "कार्यक्षेत्र सुरू केले जात आहे...",
      "welcome.trial.cta": "माझ्या कार्यक्षेत्रात प्रवेश करा",
      "welcome.trial.guarantee": "कोणतेही स्वयंचलित शुल्क नाही.",
      "tour.step_stalled.title": "रखडलेली ध्येये सूचना",
      "tour.step_stalled.desc_pro": "जेव्हा ध्येयांची गती कमी होते, तेव्हा हे कार्ड तुम्हाला ते संग्रहित करण्यात किंवा एआय कोचसह विचार करण्यात मदत करते.",
      "tour.step_stalled.desc_starter": "जेव्हा ध्येयांची गती कमी होते, तेव्हा हे कार्ड तुम्हाला ते संग्रहित करण्यात किंवा मार्ग मोकळा करण्यासाठी एक छोटी तात्काळ कृती जोडण्यास मदत करते।",
      "dialog.delete.being.title": "हे अस्तित्व काढून टाकायचे?",
      "dialog.delete.being.desc": "या ओळखीसोबत सर्व जोडलेली ध्येये आणि कामे देखील काढून टाकली जातील.",
      "dialog.delete.want.title": "हे ध्येय काढून टाकायचे?",
      "dialog.delete.want.desc": "या ध्येयासोबत सर्व जोडलेली कामे देखील काढून टाकली जातील.",
      "dialog.delete.todo.title": "हे काम काढून टाकायचे?",
      "dialog.delete.todo.desc": "हे काम कायमचे काढून टाकले जाईल.",
      "dialog.delete.confirm": "काढून टाका",
      "dialog.delete.cancel": "रद्द करा"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
